(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-category"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('collection-category')) {
      customElements.define(
        'collection-category',
        class CollectionCategory extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            window.starryEventBus.on('roInitStarrySwiper', () => {
              this.init();
            });
          }
          init() {
            // 选择 ro-product 区块内的 swiper 容器，必须和 HTML class 保持一致
            const swiperDom = this.querySelector('.collection-category__swiper');
            const scrollbarDom = this.querySelector('.swiper-scrollbar');
            const prevButton = this.querySelector('.navigation_prev');
            const nextButton = this.querySelector('.navigation_next');
            new Swiper(swiperDom, {
              slidesPerView: 'auto', // 根据slide宽度自适应展示数量
              slidesPerGroup: 1, // 每次只切换一个slide
              spaceBetween: 16,
              slidesOffsetBefore: 16,
              slidesOffsetAfter: 16,
              centeredSlides: false,
              navigation: {
                prevEl: prevButton,
                nextEl: nextButton,
              },
              scrollbar: {
                el: scrollbarDom,
                draggable: true,
              },
              breakpoints: {
                577: {
                  spaceBetween: 24,
                  slidesOffsetBefore: 32,
                  slidesOffsetAfter: 32,
                },
                1201: {
                  spaceBetween: 24,
                  slidesOffsetBefore: 0,
                  slidesOffsetAfter: 0,
                },
              },
            });

            // 获取系列列表并绑定点击事件
            const allCollections = document.querySelectorAll('.collection-category__product_card');
            allCollections.forEach((item) => {
              item.addEventListener('click', (e) => {
                // 获取data-current-active
                const dataCurrentActive = item.getAttribute('data-current-active');
                if (dataCurrentActive == 'true') return;
                // 获取当前点击元素的 data-link 属性值
                const dataLink = item.getAttribute('data-link');
                if (!dataLink) return;
                window.open(dataLink, '_self');
              });
            });
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-filter"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // 在这里编写需要在文档加载完成后执行的代码
    if (!customElements.get('collection-filter')) {
      customElements.define(
        'collection-filter',
        class CollectionFilter extends HTMLElement {
          productDetailModalBigPictrueSwiper = null;
          productDetailModalSmallPictrueSwiper = null;
          shopMoneyFormat = null;
          productInventoryQuantity = null;
          productDetailModalCopy = null;
          swiper = null;
          constructor() {
            super();
          }

          connectedCallback() {
            this.init();
            this.initMobileFilterItemEvent();
            this.initDrawer();
            this.initPagination();
            this.initFilter();
            this.initFilterWrapper();
          }

          onSubmitHandler(id = 'CollectionFiltersForm') {
            const formData = new FormData(this.querySelector(`#${id}`));
            const searchParams = new URLSearchParams(formData).toString();

            // 获取当前 URL 的所有参数
            const currentUrlParams = new URLSearchParams(window.location.search);
            const qParam = currentUrlParams.get('q');
            const typeParam = currentUrlParams.get('type');
            const sortByParam = currentUrlParams.get('sort_by');

            // 构建新的 URL
            let url = `${window.location.pathname}?${searchParams}`;

            // 添加需要保留的参数
            if (qParam) {
              url += `&q=${qParam}`;
            }
            if (typeParam) {
              url += `&type=${typeParam}`;
            }
            if (sortByParam) {
              url += `&sort_by=${sortByParam}`;
            }

            // 去除page参数
            url = url.replace(/page=\d+/, '');

            // 更细地址参数
            window.history.pushState({}, '', url);
            this.renderSectionFromFetch(url);
          }

          renderSectionFromFetch(url) {
            const _this = this;
            window.redodo.showLoading();

            fetch(url)
              .then((response) => {
                if (response.status === 200) {
                  return response.text();
                } else {
                  throw new Error('Network response was not ok');
                }
              })
              .then((responseText) => {
                const html = responseText;
                if (html) {
                  _this.renderProductGrid(html);
                }
                window.redodo.hideLoading();
                window.scrollTo({
                  top: 0,
                  behavior: 'smooth',
                });
              })
              .catch((error) => {
                console.error('Error fetching data:', error);
                window.redodo.hideLoading();
              });
          }

          renderProductGrid(html) {
            const parsedDoc = new DOMParser().parseFromString(html, 'text/html');
            const innerHTML = parsedDoc.getElementById('CollectionProductGrid')?.innerHTML;
            this.querySelector('#CollectionProductGrid').innerHTML = innerHTML;

            const filterCount = parsedDoc.getElementById('filter_count')?.innerHTML;
            if (filterCount) {
              this.querySelector('#filter_count').innerHTML = filterCount;
            }

            const filterCountMobile = parsedDoc.getElementById('filter_count_mobile')?.innerHTML;
            if (filterCountMobile) {
              this.querySelector('#filter_count_mobile').innerHTML = filterCountMobile;
            }

            const CollectionFiltersForm = this.querySelector('#CollectionFiltersForm');
            const mobileFilterForm = this.querySelector('#mobileFilterForm');

            const CollectionFiltersFormInnerHTML = parsedDoc.getElementById('CollectionFiltersForm')?.innerHTML;
            if (CollectionFiltersFormInnerHTML) {
              CollectionFiltersForm.innerHTML = CollectionFiltersFormInnerHTML;
            }

            const mobileFilterFormInnerHTML = parsedDoc.getElementById('mobileFilterForm')?.innerHTML;
            if (mobileFilterFormInnerHTML) {
              mobileFilterForm.innerHTML = mobileFilterFormInnerHTML;
            }

            this.removeInputEvent();

            this.init();
            this.initFilter();
            this.initPagination();
            this.closeFilterWrapper();
            this.initMobileFilterItemEvent();
            this.initDrawer();
            this.initFilterWrapper();
            if (typeof fetchInitCompare === 'function') {
              fetchInitCompare();
            }
          }

          initFilter() {
            const _this = this;
            const showFilter = this.querySelectorAll('.showFilter');
            showFilter.forEach((element) => {
              element.addEventListener('click', function (event) {
                event.stopPropagation();
                _this.querySelectorAll('.filter_wrapper').forEach((wrapper) => {
                  wrapper.classList.remove('hidden');
                });
                // 禁用body滚动
                window.redodo.disableScroll();
              });
            });

            const mobileFilterClose = this.querySelectorAll('.mobile_filter_close');
            mobileFilterClose.forEach((element) => {
              element.addEventListener('click', function () {
                _this.closeFilterWrapper();
                // 启用body滚动
                window.redodo.enableScroll();
              });
            });
          }

          closeFilterWrapper() {
            this.querySelectorAll('.filter_wrapper').forEach((wrapper) => {
              wrapper.classList.add('hidden');
            });
          }

          initMobileFilterItemEvent() {
            const _this = this;
            const mobileFilterItem = this.querySelectorAll('#CollectionFiltersForm .mobile_filter_item');
            const debouncedOnClick = window.redodo.debounce(function () {
              _this.onSubmitHandler();
            }, 500);

            mobileFilterItem.forEach(function (item) {
              item.addEventListener('click', function (event) {
                event.stopPropagation();
                if (event.target.tagName === 'INPUT') {
                  return;
                }

                const input = item.querySelector('input');
                if (input.disabled) {
                  return;
                }

                if (input.checked) {
                  input.checked = false;
                } else {
                  input.checked = true;
                }
                debouncedOnClick();
              });
            });

            const filterReset = this.querySelectorAll('.filter-pc_reset');
            filterReset.forEach((element) => {
              element.addEventListener('click', function () {
                const mobileFilterForm = _this.querySelector('#CollectionFiltersForm');
                const inputs = mobileFilterForm.querySelectorAll('input');
                const progress = _this.querySelectorAll('.price-range-wrapper .progress');

                _this.removeInputEvent();

                inputs.forEach((input) => {
                  if (input.checked && input.type === 'checkbox') {
                    input.checked = false;
                  }
                  if (input.classList.contains('min-range-input')) {
                    input.value = 0;
                  }
                  if (input.classList.contains('max-range-input')) {
                    const max = parseFloat(input.getAttribute('max'));
                    input.value = max;
                  }
                  if (input.classList.contains('range-min')) {
                    input.value = 0;
                  }
                  if (input.classList.contains('range-max')) {
                    const max = parseFloat(input.getAttribute('max'));
                    input.value = max;
                  }
                });

                progress.forEach((prog) => {
                  prog.style.right = '0';
                });

                _this.onSubmitHandler('CollectionFiltersForm');
              });
            });
          }

          initPagination() {
            const _this = this;
            const pagination = this.querySelector('.pagination');
            if (!pagination) return;

            const pages = pagination.querySelectorAll('.page');
            pages.forEach((page) => {
              page.addEventListener('click', function (event) {
                event.preventDefault();
                let urlParams = new URLSearchParams(window.location.search);
                urlParams.set('page', this.textContent);
                const url = window.location.pathname + '?' + urlParams.toString();
                window.history.pushState({}, '', url);
                _this.renderSectionFromFetch(url);
              });
            });

            const prev = pagination.querySelector('.prev');
            if (prev) {
              prev.addEventListener('click', function (event) {
                event.preventDefault();
                let urlParams = new URLSearchParams(window.location.search);
                const page = parseInt(urlParams.get('page')) || 1;
                if (page > 1) {
                  urlParams.set('page', page - 1);
                  const url = window.location.pathname + '?' + urlParams.toString();
                  window.history.pushState({}, '', url);
                  _this.renderSectionFromFetch(url);
                }
              });
            }

            const next = pagination.querySelector('.next');
            if (next) {
              next.addEventListener('click', function (event) {
                event.preventDefault();
                let urlParams = new URLSearchParams(window.location.search);
                const page = parseInt(urlParams.get('page')) || 1;
                urlParams.set('page', page + 1);
                const url = window.location.pathname + '?' + urlParams.toString();
                window.history.pushState({}, '', url);
                _this.renderSectionFromFetch(url);
              });
            }
          }

          initShowMore() {
            const _this = this;
            const showMoreButtons = this.querySelectorAll('[data-show-more]');
            let height;
            let newHeight;
            let lastFilterLabel = '';

            showMoreButtons.forEach((button) => {
              button.addEventListener('click', function () {
                const filterLabel = this.getAttribute('data-show-more');
                let filterItemWrapper = _this.querySelector(`[data-filter-wrapper="${filterLabel}"]`);
                _this.querySelectorAll(`[data-filter-more="${filterLabel}"]`).forEach((el) => {
                  el.classList.add('hidden');
                });

                // 记录当前filter_item_wrapper的高度
                filterItemWrapper.style.height = 'auto';
                const filterItemWrapperHeight = filterItemWrapper.offsetHeight;
                height = filterItemWrapperHeight;

                _this.querySelectorAll(`[data-filter-more="${filterLabel}"]`).forEach((el) => {
                  el.classList.remove('hidden');
                });

                _this.querySelectorAll(`[data-show-less="${filterLabel}"]`).forEach((el) => {
                  el.classList.remove('hidden');
                  el.classList.add('flex');
                });

                _this.querySelectorAll(`[data-show-more="${filterLabel}"]`).forEach((el) => {
                  el.classList.add('hidden');
                });

                if (newHeight && lastFilterLabel === filterLabel) {
                  filterItemWrapper.style.height = height + 'px';
                  setTimeout(() => {
                    filterItemWrapper.style.height = newHeight + 'px';
                  }, 50);
                } else {
                  lastFilterLabel = filterLabel;
                  // 记录最新filter_item_wrapper的高度
                  filterItemWrapper = _this.querySelector(`[data-filter-wrapper="${filterLabel}"]`);
                  const newFilterItemWrapperHeight = filterItemWrapper.offsetHeight;
                  filterItemWrapper.style.height = filterItemWrapperHeight + 'px';
                  newHeight = newFilterItemWrapperHeight;
                  setTimeout(() => {
                    filterItemWrapper.style.height = newFilterItemWrapperHeight + 'px';
                  }, 50);
                }
              });
            });

            const showLessButtons = this.querySelectorAll('[data-show-less]');
            showLessButtons.forEach((button) => {
              button.addEventListener('click', function () {
                const filterLabel = this.getAttribute('data-show-less');
                let filterItemWrapper = _this.querySelector(`[data-filter-wrapper="${filterLabel}"]`);

                _this.querySelectorAll(`[data-show-less="${filterLabel}"]`).forEach((el) => {
                  el.classList.add('hidden');
                });

                _this.querySelectorAll(`[data-show-more="${filterLabel}"]`).forEach((el) => {
                  el.classList.remove('hidden');
                  el.classList.add('flex');
                });

                setTimeout(() => {
                  filterItemWrapper.style.height = height - 5 + 'px';
                }, 50);
              });
            });
          }

          initDrawer() {
            const _this = this;
            const pcFilterWrapper = this.querySelector('.collection-part-filter');
            const drawers = pcFilterWrapper.querySelectorAll('.filter_item_drawer');

            drawers.forEach((drawer) => {
              drawer.addEventListener('click', function () {
                const filterLabel = this.getAttribute('data-filter-drawer');
                let filterItemWrapper = _this.querySelector(`[data-filter-wrapper="${filterLabel}"]`);
                let filterOpen = this.getAttribute('data-filter-open') === 'true';

                if (filterOpen) {
                  console.log(111, filterLabel);
                  // 实现收起
                  this.setAttribute('data-filter-open', 'false');

                  _this.querySelectorAll(`[data-show-more="${filterLabel}"]`).forEach((el) => {
                    el.style.opacity = '0';
                  });

                  _this.querySelectorAll(`[data-show-less="${filterLabel}"]`).forEach((el) => {
                    el.style.opacity = '0';
                  });

                  this.querySelectorAll('.filter_item_down').forEach((el) => {
                    el.classList.remove('hidden');
                  });

                  this.querySelectorAll('.filter_item_up').forEach((el) => {
                    el.classList.add('hidden');
                  });

                  const filterItemWrapperHeight = filterItemWrapper.offsetHeight;
                  filterItemWrapper.style.height = filterItemWrapperHeight + 'px';

                  setTimeout(() => {
                    filterItemWrapper.style.height = '0';
                    _this.querySelectorAll(`[data-more-wrapper="${filterLabel}"]`).forEach((el) => {
                      el.classList.add('hidden');
                    });
                  }, 50);
                } else {
                  console.log(33);
                  // 实现展开
                  this.setAttribute('data-filter-open', 'true');

                  _this.querySelectorAll(`[data-show-more="${filterLabel}"]`).forEach((el) => {
                    el.style.opacity = '1';
                    el.classList.remove('hidden');
                  });

                  _this.querySelectorAll(`[data-show-less="${filterLabel}"]`).forEach((el) => {
                    el.style.opacity = '1';
                    el.classList.add('hidden');
                  });

                  this.querySelectorAll('.filter_item_down').forEach((el) => {
                    el.classList.add('hidden');
                  });

                  this.querySelectorAll('.filter_item_up').forEach((el) => {
                    el.classList.remove('hidden');
                  });

                  _this.querySelectorAll(`[data-filter-more="${filterLabel}"]`).forEach((el) => {
                    el.classList.add('hidden');
                    el.parentElement.classList.remove('hidden');
                  });

                  filterItemWrapper.style.height = 'auto';
                  const newFilterItemWrapperHeight = filterItemWrapper.offsetHeight;
                  filterItemWrapper.style.height = '0';

                  setTimeout(() => {
                    filterItemWrapper.style.height = newFilterItemWrapperHeight + 'px';
                    _this.querySelectorAll(`[data-more-wrapper="${filterLabel}"]`).forEach((el) => {
                      el.classList.remove('hidden');
                    });
                  }, 50);
                }
              });
            });
          }

          initFilterWrapper() {
            const _this = this;
            const filterWrapper = this.querySelector('.filter_wrapper');
            if (!filterWrapper) return;

            const drawers = filterWrapper.querySelectorAll('.filter_item_drawer');
            drawers.forEach((drawer) => {
              drawer.addEventListener('click', function () {
                const filterLabel = this.getAttribute('data-filter-drawer');
                let filterItemWrapper = filterWrapper.querySelector(`[data-filter-wrapper="${filterLabel}"]`);
                let filterOpen = this.getAttribute('data-filter-open') === 'true';

                if (filterOpen) {
                  // 实现收起
                  this.setAttribute('data-filter-open', 'false');

                  filterWrapper.querySelectorAll(`[data-show-more="${filterLabel}"]`).forEach((el) => {
                    el.style.opacity = '0';
                  });

                  filterWrapper.querySelectorAll(`[data-show-less="${filterLabel}"]`).forEach((el) => {
                    el.style.opacity = '0';
                  });

                  this.querySelectorAll('.filter_item_down').forEach((el) => {
                    el.classList.remove('hidden');
                  });

                  this.querySelectorAll('.filter_item_up').forEach((el) => {
                    el.classList.add('hidden');
                  });

                  filterItemWrapper.style.height = 'auto';
                  const filterItemWrapperHeight = filterItemWrapper.offsetHeight;
                  filterItemWrapper.style.height = filterItemWrapperHeight + 'px';

                  setTimeout(() => {
                    filterItemWrapper.style.height = '0';
                    filterWrapper.querySelectorAll(`[data-more-wrapper="${filterLabel}"]`).forEach((el) => {
                      el.classList.add('hidden');
                    });
                  }, 50);
                } else {
                  // 实现展开
                  this.setAttribute('data-filter-open', 'true');

                  filterWrapper.querySelectorAll(`[data-show-more="${filterLabel}"]`).forEach((el) => {
                    el.style.opacity = '1';
                    el.classList.remove('hidden');
                  });

                  filterWrapper.querySelectorAll(`[data-show-less="${filterLabel}"]`).forEach((el) => {
                    el.style.opacity = '1';
                    el.classList.add('hidden');
                  });

                  this.querySelectorAll('.filter_item_down').forEach((el) => {
                    el.classList.add('hidden');
                  });

                  this.querySelectorAll('.filter_item_up').forEach((el) => {
                    el.classList.remove('hidden');
                  });

                  filterWrapper.querySelectorAll(`[data-filter-more="${filterLabel}"]`).forEach((el) => {
                    el.classList.add('hidden');
                    el.parentElement.classList.remove('hidden');
                  });

                  filterItemWrapper.style.height = 'auto';
                  const newFilterItemWrapperHeight = filterItemWrapper.offsetHeight;
                  filterItemWrapper.style.height = '0';

                  setTimeout(() => {
                    filterItemWrapper.style.height = newFilterItemWrapperHeight + 'px';
                    filterWrapper.querySelectorAll(`[data-more-wrapper="${filterLabel}"]`).forEach((el) => {
                      el.classList.remove('hidden');
                    });
                  }, 50);
                }
              });
            });

            let height;
            let newHeight;
            let lastFilterLabel = '';

            const showMoreButtons = filterWrapper.querySelectorAll('[data-show-more]');
            showMoreButtons.forEach((button) => {
              button.addEventListener('click', function () {
                const filterLabel = this.getAttribute('data-show-more');
                let filterItemWrapper = filterWrapper.querySelector(`[data-filter-wrapper="${filterLabel}"]`);

                filterWrapper.querySelectorAll(`[data-filter-more="${filterLabel}"]`).forEach((el) => {
                  el.classList.add('hidden');
                });

                // 记录当前filter_item_wrapper的高度
                filterItemWrapper.style.height = 'auto';
                const filterItemWrapperHeight = filterItemWrapper.offsetHeight;
                height = filterItemWrapperHeight;

                filterWrapper.querySelectorAll(`[data-filter-more="${filterLabel}"]`).forEach((el) => {
                  el.classList.remove('hidden');
                });

                filterWrapper.querySelectorAll(`[data-show-less="${filterLabel}"]`).forEach((el) => {
                  el.classList.remove('hidden');
                  el.classList.add('flex');
                });

                filterWrapper.querySelectorAll(`[data-show-more="${filterLabel}"]`).forEach((el) => {
                  el.classList.add('hidden');
                });

                if (newHeight && lastFilterLabel === filterLabel) {
                  filterItemWrapper.style.height = height + 'px';
                  setTimeout(() => {
                    filterItemWrapper.style.height = newHeight + 'px';
                  }, 50);
                } else {
                  lastFilterLabel = filterLabel;
                  // 记录最新filter_item_wrapper的高度
                  filterItemWrapper = filterWrapper.querySelector(`[data-filter-wrapper="${filterLabel}"]`);
                  const newFilterItemWrapperHeight = filterItemWrapper.offsetHeight;
                  filterItemWrapper.style.height = filterItemWrapperHeight + 'px';
                  newHeight = newFilterItemWrapperHeight;
                  setTimeout(() => {
                    filterItemWrapper.style.height = newFilterItemWrapperHeight + 'px';
                  }, 50);
                }
              });
            });

            const showLessButtons = filterWrapper.querySelectorAll('[data-show-less]');
            showLessButtons.forEach((button) => {
              button.addEventListener('click', function () {
                const filterLabel = this.getAttribute('data-show-less');
                let filterItemWrapper = filterWrapper.querySelector(`[data-filter-wrapper="${filterLabel}"]`);

                filterWrapper.querySelectorAll(`[data-show-less="${filterLabel}"]`).forEach((el) => {
                  el.classList.add('hidden');
                });

                filterWrapper.querySelectorAll(`[data-show-more="${filterLabel}"]`).forEach((el) => {
                  el.classList.remove('hidden');
                  el.classList.add('flex');
                });

                setTimeout(() => {
                  filterItemWrapper.style.height = height + 'px';
                }, 50);
              });
            });

            const mobileFilterItem = filterWrapper.querySelectorAll('.mobile_filter_item');
            mobileFilterItem.forEach(function (item) {
              item.addEventListener('click', function (event) {
                event.stopPropagation();
                if (event.target.tagName === 'INPUT') {
                  return;
                }

                const input = item.querySelector('input');
                if (input.disabled) {
                  return;
                }

                if (input.checked) {
                  input.checked = false;
                } else {
                  input.checked = true;
                }
              });
            });

            const filterReset = filterWrapper.querySelectorAll('.filter_reset');
            filterReset.forEach((element) => {
              element.addEventListener('click', function () {
                const mobileFilterForm = filterWrapper.querySelector('#mobileFilterForm');
                const inputs = mobileFilterForm.querySelectorAll('input');
                const progress = filterWrapper.querySelectorAll('.price-range-wrapper .progress');

                inputs.forEach((input) => {
                  if (window.getComputedStyle(input).display !== 'none') {
                    input.checked = false;
                  }
                  if (input.classList.contains('min-range-input')) {
                    input.value = 0;
                  }
                  if (input.classList.contains('max-range-input')) {
                    const max = parseFloat(input.getAttribute('max'));
                    input.value = max;
                  }
                  if (input.classList.contains('range-min')) {
                    input.value = 0;
                  }
                  if (input.classList.contains('range-max')) {
                    const max = parseFloat(input.getAttribute('max'));
                    input.value = max;
                  }
                });

                progress.forEach((prog) => {
                  prog.style.right = '0';
                });

                _this.onSubmitHandler('mobileFilterForm');
                filterWrapper.classList.add('hidden');
              });
            });

            const applyButton = filterWrapper.querySelectorAll('.filter_apply');
            applyButton.forEach((button) => {
              button.addEventListener('click', function () {
                _this.onSubmitHandler('mobileFilterForm');
              });
            });
          }

          debouncedOnSubmit = window.redodo.debounce((event) => {
            event.preventDefault();
            this.onSubmitHandler();
          }, 500);

          init() {
            const _this = this;
            if (this.querySelector('#CollectionFiltersForm')) {
              this.querySelector('#CollectionFiltersForm').addEventListener('input', this.debouncedOnSubmit.bind(this));
            }

            // 获取data-sortby的元素
            const dataSortbys = this.querySelectorAll('[data-sortby]');
            dataSortbys.forEach((element) => {
              element.addEventListener('click', function (event) {
                // 获取data-sortby的值
                const dataSortbyValue = this.getAttribute('data-sortby');
                // 获取地址栏所有参数
                const urlParams = new URLSearchParams(window.location.search);
                urlParams.set('sort_by', dataSortbyValue);
                const url = window.location.pathname + '?' + urlParams.toString();
                window.history.pushState({}, '', url);
                _this.renderSectionFromFetch(url);
              });
            });
          }

          removeInputEvent() {
            if (this.querySelector('#CollectionFiltersForm')) {
              this.querySelector('#CollectionFiltersForm').removeEventListener(
                'input',
                this.debouncedOnSubmit.bind(this)
              );
            }
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-hot-products"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('collection-hot-products')) {
      customElements.define(
        'collection-hot-products',
        class CollectionHotProducts extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            window.starryEventBus.on('roInitStarrySwiper', () => {
              this.initSwiper();
            });

            // 事件绑定
            const functionTagsContainers = this.querySelectorAll('.collection-hot-products__product_function_tags');
            this.tagFunctionScroll(functionTagsContainers);
          }
          disconnectedCallback() {
            this.clearListeners();
          }
          initSwiper() {
            const swiperDom = this.querySelector('.collection-hot-products__swiper');
            const scrollbarDom = this.querySelector('.swiper-scrollbar');
            new Swiper(swiperDom, {
              slidesPerView: 'auto',
              spaceBetween: 16,
              slidesOffsetBefore: 16,
              slidesOffsetAfter: 16,
              freeMode: true, // 👈 开启自由滚动
              freeModeMomentum: true, // 松手后有惯性滑动
              centeredSlides: false,
              noSwipingClass: 'collection-hot-products__product_function_tags',
              scrollbar: {
                el: scrollbarDom,
                draggable: true,
              },
              breakpoints: {
                577: {
                  spaceBetween: 24,
                  slidesOffsetBefore: 32,
                  slidesOffsetAfter: 32,
                },
                1440: {
                  spaceBetween: 24,
                  slidesOffsetBefore: 0,
                  slidesOffsetAfter: 0,
                },
              },
            });
          }

          tagFunctionScroll(elementList, initSpeed = 10, InitReturnSpeed = 3) {
            let speed = initSpeed * 1000;
            let returnSpeed = InitReturnSpeed * 1000;
            if (!elementList.length) return;

            // 检测屏幕宽度，1200px及以下不触发
            if (window.innerWidth <= 1200) return;

            // 存储每个容器的原始滚动位置和动画帧ID
            const originalScrollPositions = new Map();
            const animationFrameIds = new Map();

            // 自定义平滑滚动函数 - 固定时间移动相同距离
            const smoothScroll = (element, target, duration) => {
              // 先取消之前的动画
              if (animationFrameIds.has(element)) {
                cancelAnimationFrame(animationFrameIds.get(element));
              }

              const start = element.scrollLeft;
              const distance = target - start;
              const startTime = performance.now();

              function animateScroll(currentTime) {
                const elapsed = currentTime - startTime;

                if (elapsed < duration) {
                  // 固定速度滚动
                  const progress = elapsed / duration;
                  element.scrollLeft = start + distance * progress;
                  const frameId = requestAnimationFrame(animateScroll);
                  animationFrameIds.set(element, frameId);
                } else {
                  // 确保最终位置准确
                  element.scrollLeft = target;
                  animationFrameIds.delete(element);
                }
              }

              const frameId = requestAnimationFrame(animateScroll);
              animationFrameIds.set(element, frameId);
            };

            // 为每个容器添加事件监听
            elementList.forEach((container) => {
              originalScrollPositions.set(container, container.scrollLeft);

              // 使用防抖包装事件处理函数
              const debouncedMouseEnter = window.redodo.debounce(function () {
                const targetScroll = container.scrollWidth - container.clientWidth;

                if (speed === 0) {
                  container.scrollLeft = targetScroll;
                } else {
                  // 计算实际需要的滚动时间（基于距离）
                  const distance = targetScroll - container.scrollLeft;
                  const actualDuration = Math.abs(distance) * (speed / 1000);
                  smoothScroll(container, targetScroll, actualDuration);
                }
              }, 50); // 50ms防抖延迟

              const debouncedMouseLeave = window.redodo.debounce(function () {
                const originalScrollLeft = originalScrollPositions.get(container);

                if (returnSpeed === 0) {
                  container.scrollLeft = originalScrollLeft;
                } else {
                  // 使用更快的速度返回
                  const distance = originalScrollLeft - container.scrollLeft;
                  const actualDuration = Math.abs(distance) * (returnSpeed / 1000);
                  smoothScroll(container, originalScrollLeft, actualDuration);
                }
              }, 50); // 50ms防抖延迟

              // 存储处理函数以便后续移除
              container._mouseEnterHandler = debouncedMouseEnter;
              container._mouseLeaveHandler = debouncedMouseLeave;

              container.addEventListener('mouseenter', debouncedMouseEnter);
              container.addEventListener('mouseleave', debouncedMouseLeave);
            });

            // 添加窗口resize监听
            const handleResize = () => {
              if (window.innerWidth <= 1200) {
                this.clearListeners.call(this);
              }
            };

            window.addEventListener('resize', handleResize);
            this._resizeHandler = handleResize;
          }

          // 清除监听
          clearListeners() {
            const functionTagsContainers = this.querySelectorAll('.collection-hot-products__product_function_tags');

            functionTagsContainers.forEach((container) => {
              if (container._mouseEnterHandler) {
                container.removeEventListener('mouseenter', container._mouseEnterHandler);
                delete container._mouseEnterHandler;
              }

              if (container._mouseLeaveHandler) {
                container.removeEventListener('mouseleave', container._mouseLeaveHandler);
                delete container._mouseLeaveHandler;
              }
            });

            if (this._resizeHandler) {
              window.removeEventListener('resize', this._resizeHandler);
              delete this._resizeHandler;
            }
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-marquee"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (!customElements.get('collection-marquee')) {
      customElements.define(
        'collection-marquee',
        class CollectionMarquee extends HTMLElement {
          constructor() {
            super();
          }
          marqueeLeftTimer;
          marqueerightTimer;
          marqueeSpeed = 1;
          connectedCallback() {
            const marquee = this.querySelector('.marquee_list');
            this.initMarquee(marquee);
          }

          disconnectedCallback() {
            // 清理定时器防止内存泄漏
            if (this.marqueeLeftTimer) {
              this.marqueeLeftTimer = null;
              clearInterval(this.marqueeLeftTimer);
            }
            if (this.marqueeRightTimer) {
              this.marqueeRightTimer = null;
              clearInterval(this.marqueeRightTimer);
            }
          }

          // 初始化跑马灯
          initMarquee(track) {
            const direction = track.dataset.direction || 'left';
            const pauseType = track.dataset.pauseType || 'smooth';
            const totalTime = track.dataset.totalTime || 15;
            const itemsLength = track.children.length;
            // 克隆足够多的副本确保无缝衔接（至少克隆两次）
            const cloneCount = Math.max(2, Math.ceil(3 / itemsLength)); // 至少克隆2次，item少时克隆更多
            let cloneHtml = '';
            for (let i = 0; i < cloneCount; i++) {
              cloneHtml += track.innerHTML;
            }
            track.insertAdjacentHTML('beforeend', cloneHtml);
            const computedGap = getComputedStyle(track);
            const trackGap = parseFloat(computedGap.gap);

            requestAnimationFrame(() => {
              const itemsWidth = Array.from(track.children)
                .slice(0, itemsLength)
                .reduce((total, item) => total + item.offsetWidth + trackGap, 0);

              const speed = parseFloat(track.dataset.speed) || 1;
              const duration = totalTime / speed;

              let startX, endX;
              if (direction === 'right') {
                startX = -itemsWidth;
                endX = 0;
              } else {
                startX = 0;
                endX = -itemsWidth;
              }

              gsap.set(track, { x: startX });

              const tl = gsap.to(track, {
                x: endX,
                duration: duration,
                ease: 'none',
                repeat: -1,
                onUpdate: function () {
                  const currentX = this.targets()[0]._gsap.x;
                  const absX = Math.abs(currentX);

                  const shouldReset =
                    direction === 'right'
                      ? currentX >= -1 // 向右滚动即将到达0时
                      : absX >= itemsWidth - 1; // 向左滚动即将超过一组宽度时

                  if (shouldReset) {
                    requestAnimationFrame(() => {
                      this.targets()[0].style.transition = 'none';
                      gsap.set(track, { x: startX });
                      this.restart();
                    });
                  }
                },
              });

              track.addEventListener('mouseenter', () => {
                if (pauseType === 'immediate') {
                  tl.pause();
                } else {
                  gsap.to(tl, {
                    timeScale: 0,
                    duration: 1,
                    ease: 'power2.inOut',
                  });
                }
              });

              track.addEventListener('mouseleave', () => {
                if (pauseType === 'immediate') {
                  tl.resume();
                } else {
                  gsap.to(tl, {
                    timeScale: 1,
                    duration: 1,
                    ease: 'power2.inOut',
                  });
                }
              });
            });
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-nav"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('collection-nav')) {
      customElements.define(
        'collection-nav',
        class CollectionNav extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            window.starryEventBus.on('roInitStarrySwiper', () => {
              this.init();
            });
            this.handleScroll();
            this.initAncor();
            this.handleNavSticky();
          }

          disconnectedCallback() {
            window.removeEventListener('scroll');
            window.removeEventListener('resize');
          }
          init() {
            // 选择 ro-product 区块内的 swiper 容器，必须和 HTML class 保持一致
            const swiperDom = this.querySelector('.swiper');
            const prevButton = this.querySelector('.navigation_prev');
            const nextButton = this.querySelector('.navigation_next');
            new Swiper(swiperDom, {
              slidesPerView: 'auto',
              spaceBetween: 30,
              slidesOffsetBefore: 0,
              slidesOffsetAfter: 0,
              centeredSlides: false,
              navigation: {
                prevEl: prevButton,
                nextEl: nextButton,
              },
              breakpoints: {
                1201: {
                  spaceBetween: 24,
                },
              },
            });
          }

          initAncor() {
            // 监听所有锚点链接的点击事件
            const _this = this;
            this.querySelectorAll('a[href*="#"]').forEach((anchor) => {
              anchor.addEventListener('click', function (e) {
                e.preventDefault();

                const targetId = this.getAttribute('href').substring(1);
                const targetElement = document.getElementById(targetId);

                if (targetElement) {
                  // 平滑滚动到目标位置
                  targetElement.scrollIntoView({
                    behavior: 'smooth',
                  });

                  // 记录当前锚点
                  window.currentAnchor = targetId;
                  console.log('跳转到锚点:', targetId);

                  // 更新活跃状态
                  _this.updateActiveAnchor(targetId);
                }
              });
            });
          }

          handleNavSticky() {
            const navElement = this.querySelector('.collection-nav__container');
            if (!navElement) return;

            const initialOffsetTop = navElement.offsetTop;
            let isSticky = false;

            // 创建占位元素 - 放在navElement的同一层级
            const placeholder = document.createElement('div');
            placeholder.className = 'collection-nav__placeholder';
            placeholder.style.height = navElement.offsetHeight + 'px';
            placeholder.style.display = 'none'; // 初始隐藏

            // 插入到navElement之前
            navElement.parentNode.insertBefore(placeholder, navElement);

            const scrollHandler = () => {
              const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

              if (scrollTop > initialOffsetTop && !isSticky) {
                navElement.classList.add('collection-sticky-nav');
                placeholder.style.display = 'block'; // 显示占位元素
                placeholder.style.height = navElement.offsetHeight + 'px';
                isSticky = true;
              } else if (scrollTop <= initialOffsetTop && isSticky) {
                navElement.classList.remove('collection-sticky-nav');
                placeholder.style.display = 'none'; // 隐藏占位元素
                isSticky = false;
              }
            };

            // 使用防抖函数
            const debouncedScroll = window.redodo.debounce(scrollHandler, 10);
            const debouncedResize = window.redodo.debounce(() => {
              if (isSticky) {
                placeholder.style.height = navElement.offsetHeight + 'px';
              }
            }, 100);

            // 初始检查和添加监听
            scrollHandler();
            window.addEventListener('scroll', debouncedScroll);
            window.addEventListener('resize', debouncedResize);
          }

          // 监听全局滚动，处理吸顶效果与顶部导航栏展示，方式叠加展示
          handleScroll() {
            // 监听滚动事件，判断当前顶部导航是否吸顶展示
            const starryHeaderEle = document.querySelector('.ro-header__container'); // 全局获取顶部导航元素
            const navElement = this.querySelector('.collection-nav__container');
            window.addEventListener('scroll', () => {
              const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
              const starryHeaderHeight = starryHeaderEle.offsetHeight;
              if (scrollTop > starryHeaderHeight) {
                setTimeout(() => {
                  navElement.style.transition = 'top 0.3s ease-in-out';
                }, 0);
                if (scrollTop < this.lastScrollTop) {
                  navElement.style.top = `${starryHeaderHeight}px`;
                  navElement.style.zIndex = `100`;
                } else {
                  navElement.style.top = 0;
                }
              }
              this.lastScrollTop = scrollTop;
            });
          }

          updateActiveAnchor(anchorId) {
            // 移除所有活跃状态
            document.querySelectorAll('a[href*="#"]').forEach((link) => {
              link.classList.remove('active');
            });

            // 添加当前活跃状态
            const activeLink = document.querySelector(`a[href="#${anchorId}"]`);
            if (activeLink) {
              activeLink.classList.add('active');
            }
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-trust"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('collection-trust')) {
      customElements.define(
        'collection-trust',
        class CollectionTrust extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            // 等待Swiper库加载完成后再执行完整初始化
            this.waitForSwiper(() => {
              this.init();
            });

            this.initTabs();
            this.handleViewClick();
            this.handleCloseClick();
          }
          init() {
            const swiperDom1 = this.querySelector('.collection-trust__swiper1');
            const prevButton1 = this.querySelector('.collection-trust__swiper1 .navigation_prev');
            const nextButton1 = this.querySelector('.collection-trust__swiper1 .navigation_next');
            const swiperDom2 = this.querySelector('.collection-trust__swiper2');
            const prevButton2 = this.querySelector('.collection-trust__swiper2 .navigation_prev');
            const nextButton2 = this.querySelector('.collection-trust__swiper2 .navigation_next');
            this.initSwier(swiperDom1, prevButton1, nextButton1);
            this.initSwier(swiperDom2, prevButton2, nextButton2);
          }
          initSwier(swiperDom, prevButton, nextButton) {
            new Swiper(swiperDom, {
              slidesPerView: 'auto', // 根据slide宽度自适应展示数量
              slidesPerGroup: 1, // 每次只切换一个slide
              spaceBetween: 16,
              slidesOffsetBefore: 0,
              slidesOffsetAfter: 0,
              centeredSlides: false,
              navigation: {
                prevEl: prevButton,
                nextEl: nextButton,
              },
              breakpoints: {
                577: {
                  spaceBetween: 24,
                },
              },
            });
          }
          // 等待Swiper库加载完成
          waitForSwiper(callback) {
            const checkSwiper = () => {
              if (typeof Swiper !== 'undefined') {
                callback();
              } else {
                setTimeout(checkSwiper, 50);
              }
            };
            checkSwiper();
          }
          handleCloseClick() {
            this.addEventListener('click', (e) => {
              // 检查点击的是关闭图标或图标内的元素
              const icon = e.target.closest('.collection-trust__whole_content_bg i');
              if (!icon) return;
              console.log(11, icon);

              // 获取父元素
              const contentBg = icon.parentElement;
              // 获取祖父元素
              const wholeContent = contentBg?.closest('.collection-trust__whole_content');
              // 查找背景元素
              const background = wholeContent?.previousElementSibling;

              // 隐藏内容
              if (wholeContent) {
                //添加类名
                wholeContent.classList.remove('collection-trust__whole_content-show');
                // wholeContent.style.transform = 'translateY(100%)';
              }

              // 隐藏背景
              if (background && background.classList.contains('collection-trust__whole_bg')) {
                background.classList.remove('collection-trust__whole_bg-show');
                // background.style.opacity = '0';
                // background.style.height = '0';
              }
            });
          }

          handleViewClick() {
            this.addEventListener('click', (e) => {
              // 检查点击的是查看按钮或按钮内的元素
              const button = e.target.closest('.collection-trust__more_btn');
              if (!button) return;

              // 获取按钮的父元素
              const parent = button.parentElement;
              // 获取父元素所有兄弟元素
              const siblings = Array.from(parent.parentElement.children);
              // 找到指定类名的兄弟元素
              const targetSibling_content = siblings.find((sibling) =>
                sibling.classList.contains('collection-trust__whole_content')
              );
              // 找到指定类名的兄弟元素
              const targetSibling_bg = siblings.find((sibling) =>
                sibling.classList.contains('collection-trust__whole_bg')
              );
              if (targetSibling_content) {
                // targetSibling_content.style.transform = 'translateY(0)';
                targetSibling_content.classList.add('collection-trust__whole_content-show');
              }
              if (targetSibling_bg) {
                targetSibling_bg.classList.add('collection-trust__whole_bg-show');
                // targetSibling_bg.style.opacity = '1';
                // targetSibling_bg.style.height = '100%';
              }
            });
          }
          // 初始化显示第一个Tab内容
          initTabs() {
            // 获取所有Tab按钮和Swiper容器
            const tabButtons = document.querySelectorAll('.collection-trust__tab_btn');
            const swipers = document.querySelectorAll('.collection-trust__swiper1, .collection-trust__swiper2');
            // 默认显示第一个Tab
            swipers.forEach((swiper) => {
              if (swiper.getAttribute('data-current-tab') === 'true') {
                swiper.style.display = 'block';
              } else {
                swiper.style.display = 'none';
              }
            });

            // 为每个Tab按钮添加点击事件
            tabButtons.forEach((button, index) => {
              button.addEventListener('click', () => {
                // 移除所有按钮的active类
                tabButtons.forEach((btn) => btn.classList.remove('active'));
                // 为当前点击的按钮添加active类
                button.classList.add('active');

                // 更新Swiper的显示状态
                swipers.forEach((swiper, swiperIndex) => {
                  if (index === swiperIndex) {
                    swiper.style.display = 'block';
                    swiper.setAttribute('data-current-tab', 'true');
                  } else {
                    swiper.style.display = 'none';
                    swiper.setAttribute('data-current-tab', 'false');
                  }
                });
              });
            });
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog-list"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('main-blog-list')) {
      customElements.define(
        'main-blog-list',
        class MainBlogList extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            window.starryEventBus.on('roInitStarrySwiper', () => {
              this.init();
            });
            // 初始化时如果是设计模式，监听section的load事件
            // 这样可以在设计模式下修改后直接能看到轮播效果
            if (window.Shopify.designMode) {
              document.addEventListener('shopify:section:load', (event) => {
                const blogLists = event.target.querySelectorAll('main-blog-list');
                blogLists.forEach((el) => {
                  if (el.init) el.init();
                });
              });
            }
          }
          init() {
            const swiper = this.querySelector('.ro-blog-list__articles_swiper');
            const swiperWrapper = this.querySelector('.ro-blog-list__swiper_wrapper');
            const swiperSlides = swiperWrapper.querySelectorAll('.ro-blog-list__swiper_slide');
            const scrollbarDom = this.querySelector('.swiper-scrollbar');
            const nextButton = this.querySelector('.navigation_next');
            const prevButton = this.querySelector('.navigation_prev');

            swiper.classList.add('swiper');
            swiperWrapper.classList.add('swiper-wrapper');
            swiperSlides.forEach((slide) => {
              slide.classList.add('swiper-slide');
            });

            this.swiper = new Swiper(swiper, {
              slidesPerView: 'auto',
              spaceBetween: 16,
              slidesOffsetBefore: 0,
              slidesOffsetAfter: 0,
              enteredSlides: false,
              allowTouchMove: true,
              touchStartPreventDefault: false,
              preventClicks: true,
              preventClicksPropagation: false,
              navigation: {
                nextEl: nextButton,
                prevEl: prevButton,
              },
              scrollbar: {
                el: scrollbarDom,
                draggable: true,
              },
              breakpoints: {
                1201: {
                  slidesPerView: 4,
                  allowTouchMove: false,
                },
              },
            });
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ro-brands"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (!customElements.get('ro-brands')) {
      customElements.define(
        'ro-brands',
        class RoBrands extends HTMLElement {
          constructor() {
            super();
          }
          marqueeLeftTimer;
          marqueeRightTimer;
          marqueeSpeed = 0.4;
          connectedCallback() {
            this.initMarquee();
          }
          // 初始化跑马灯
          initMarquee() {
            const marqueeContainers = this.querySelectorAll('.ro-brands__marquee_container');
            marqueeContainers.forEach((marqueeContainer) => {
              const direction = marqueeContainer.dataset.direction;
              const marquee = marqueeContainer.querySelector('.ro-brand__marquee');
              const marqueeItems = marquee.querySelectorAll('.ro-brand__marquee_item');

              // 计算单个项目的宽度（包括 margin）
              const firstItem = marqueeItems[0];
              const itemStyle = window.getComputedStyle(firstItem);
              const itemWidth =
                firstItem.offsetWidth + parseInt(itemStyle.marginLeft) + parseInt(itemStyle.marginRight);

              // 计算可见区域能显示多少个项目
              const containerWidth = marqueeContainer.offsetWidth;
              const visibleItems = Math.ceil(containerWidth / itemWidth);

              // 确保复制的总宽度 >= 2 * 容器宽度 + 单个 item 宽度
              const minTotalWidth = containerWidth * 2 + itemWidth;
              const neededCopies = Math.ceil(minTotalWidth / (marqueeItems.length * itemWidth));
              let clone = '';
              for (let i = 0; i < neededCopies; i++) {
                clone += marquee.innerHTML;
              }
              marquee.insertAdjacentHTML('beforeend', clone);

              // 使用 requestAnimationFrame 实现平滑动画
              let offset = 0;
              const animate = () => {
                offset = (offset + this.marqueeSpeed) % (marquee.scrollWidth / 2);
                marquee.style.transform = `translateX(${direction === 'left' ? '-' : ''}${offset}px)`;
                requestAnimationFrame(animate);
              };
              animate();
            });
          }
          disconnectedCallback() {
            this.marqueeLeftTimer = null;
            this.marqueeRightTimer = null;
            clearInterval(this.marqueeLeftTimer);
            clearInterval(this.marqueeRightTimer);
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ro-cart-drawer"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('ro-cart-drawer')) {
      customElements.define(
        'ro-cart-drawer',
        class RoCartDrawer extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.init();
          }
          init() {
            // 给遮罩层.ro-cart-drawer添加关闭事件
            this.querySelector('.ro-cart-drawer').addEventListener('click', (e) => {
              if (e.target.classList.contains('ro-cart-drawer')) {
                this.close();
              }
            });
            // 给header-close添加点击事件
            this.querySelector('.header-close').addEventListener('click', (e) => {
              this.close();
            });
          }
          open() {
            this.setAttribute('data-open', 'true');
            window.disableScroll();
          }
          close() {
            this.setAttribute('data-open', 'false');
            window.enableScroll();
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ro-endorse"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (!customElements.get('ro-endorse')) {
      customElements.define(
        'ro-endorse',
        class RoEndorse extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            const scrollContainer = document.querySelector('.ro-endorse__content');

            scrollContainer.addEventListener('wheel', (event) => {
              if (window.innerWidth <= 1024) {
                const scrollAmount = Math.min(scrollContainer.clientWidth, 200);
                scrollContainer.scrollBy({
                  left: event.deltaY > 0 ? scrollAmount : -scrollAmount,
                  behavior: 'smooth',
                });
              }
            });
          }
          disconnectedCallback() {
            this.scrollContainer.removeEventListener('wheel');
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ro-evaluation"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ro-evaluation')) {
    customElements.define(
      'ro-evaluation',
      class RoEvaluation extends HTMLElement {
        constructor() {
          super();
        }
        marqueeLeftTimer;
        marqueeRightTimer;
        marqueeSpeed = 0.4;
        connectedCallback() {
          // 初始数字跳转动画
          let countScript = document.getElementById('count-script-js');
          countScript.addEventListener('load', () => {
            this.initCountUp();
          });
          document.addEventListener('DOMContentLoaded', () => {
            this.querySelectorAll('.ro-evaluation__marquee_list').forEach((track) => {
              this.initMarquee(track);
            });
          });
        }
        disconnectedCallback() {
          this.marqueeLeftTimer = null;
          this.marqueeRightTimer = null;
          clearInterval(this.marqueeLeftTimer);
          clearInterval(this.marqueeRightTimer);
        }
        // 初始化数字
        initCountUp() {
          const numberDomList = this.querySelectorAll('.starry_count');
          if (numberDomList.length) {
            numberDomList.forEach((item) => {
              const number = Number(item.dataset.number);
              new countUp.CountUp(item, number, {
                enableScrollSpy: true,
                scrollSpyOnce: true,
                scrollSpyDelay: 600,
                formattingFn: this._formatNumber,
              });
            });
          }
        }
        _formatNumber(value) {
          if (value >= 1000000) {
            const formattedValue = (value / 1000000).toFixed(1);
            return parseFloat(formattedValue) + 'M';
          } else if (value >= 1000) {
            const formattedValue = (value / 1000).toFixed(1);
            return parseFloat(formattedValue) + 'K';
          } else {
            return value.toString();
          }
        }
        // 初始化跑马灯
        initMarquee(track) {
          const direction = track.dataset.direction || 'left';
          const pauseType = track.dataset.pauseType || 'smooth';
          const totalTime = track.dataset.totalTime || 15;
          const itemsLength = track.children.length;
          // 克隆足够多的副本确保无缝衔接（至少克隆两次）
          const cloneCount = Math.max(2, Math.ceil(3 / itemsLength)); // 至少克隆2次，item少时克隆更多
          let cloneHtml = '';
          for (let i = 0; i < cloneCount; i++) {
            cloneHtml += track.innerHTML;
          }
          track.insertAdjacentHTML('beforeend', cloneHtml);
          const computedGap = getComputedStyle(track);
          const trackGap = parseFloat(computedGap.gap);

          requestAnimationFrame(() => {
            const itemsWidth = Array.from(track.children)
              .slice(0, itemsLength)
              .reduce((total, item) => total + item.offsetWidth + trackGap, 0);

            const speed = parseFloat(track.dataset.speed) || 1;
            const duration = totalTime / speed;

            let startX, endX;
            if (direction === 'right') {
              startX = -itemsWidth;
              endX = 0;
            } else {
              startX = 0;
              endX = -itemsWidth;
            }

            gsap.set(track, { x: startX });

            const tl = gsap.to(track, {
              x: endX,
              duration: duration,
              ease: 'none',
              repeat: -1,
              onUpdate: function () {
                const currentX = this.targets()[0]._gsap.x;
                const absX = Math.abs(currentX);

                const shouldReset =
                  direction === 'right'
                    ? currentX >= -1 // 向右滚动即将到达0时
                    : absX >= itemsWidth - 1; // 向左滚动即将超过一组宽度时

                if (shouldReset) {
                  requestAnimationFrame(() => {
                    this.targets()[0].style.transition = 'none';
                    gsap.set(track, { x: startX });
                    this.restart();
                  });
                }
              },
            });

            track.addEventListener('mouseenter', () => {
              if (pauseType === 'immediate') {
                tl.pause();
              } else {
                gsap.to(tl, {
                  timeScale: 0,
                  duration: 1,
                  ease: 'power2.inOut',
                });
              }
            });

            track.addEventListener('mouseleave', () => {
              if (pauseType === 'immediate') {
                tl.resume();
              } else {
                gsap.to(tl, {
                  timeScale: 1,
                  duration: 1,
                  ease: 'power2.inOut',
                });
              }
            });
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ro-marine-application"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('ro-marine-application')) {
      customElements.define(
        'ro-marine-application',
        class RoMarineApplication extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            console.log('ro-marine-application connectedCallback');
            // 等待Swiper库加载完成后再执行完整初始化
            setTimeout(() => {
              console.log('window.innerWidth-200', window.innerWidth);
              if (window.innerWidth <= 1200) {
                this.waitForSwiper(() => {
                  console.log('ro-marine-application initMobile');
                  this.initMobile();
                });
              } else {
                this.waitForSwiper(() => {
                  console.log('ro-marine-application init');
                  this.init();
                });
              }
            }, 200);
          }
          initMobile() {
            const swiperDom = this.querySelector('.ro-marine-application__mobile_container_content_swiper');
            const prevButton = this.querySelector('.ro-marine-application__container_handle_prev');
            const nextButton = this.querySelector('.ro-marine-application__container_handle_next');
            const progressCircles = this.querySelectorAll(
              '.ro-marine-application__container_handle_next .progress-ring-progress'
            );
            const autoplayDelay = 5000; // 5秒
            new Swiper(swiperDom, {
              slidesPerView: 1,
              spaceBetween: 48,
              loop: true,
              autoplay: {
                delay: autoplayDelay,
                disableOnInteraction: false,
              },
              navigation: {
                nextEl: nextButton,
                prevEl: prevButton,
              },
              on: {
                autoplayTimeLeft(s, time, progress) {
                  // 使用CSS变量更新进度
                  progressCircles.forEach((circle) => {
                    // 确保进度为1时完全填满
                    const adjustedProgress = progress >= 0.95 ? 1 : progress;
                    circle.style.setProperty('--progress', 1 - adjustedProgress);
                  });
                },
                slideChange: () => {
                  // 切换slide后重新检测滚动性
                  setTimeout(() => {
                    this.checkDeviceListScrollability();
                  }, 100);
                },
              },
            });

            // 检测设备列表是否需要滚动，决定是否显示渐变遮罩
            this.checkDeviceListScrollability();
          }

          checkDeviceListScrollability() {
            const deviceLists = this.querySelectorAll(
              '.ro-marine-application__mobile_container_content_swiper_slide_content_device_list_wrapper'
            );

            deviceLists.forEach((deviceListWrapper) => {
              const deviceList = deviceListWrapper.querySelector(
                '.ro-marine-application__mobile_container_content_swiper_slide_content_device_list'
              );

              // 清理旧的监听器
              if (deviceListWrapper._scrollListener) {
                deviceList.removeEventListener('scroll', deviceListWrapper._scrollListener);
                deviceListWrapper._scrollListener = null;
              }

              const needsScroll = deviceList.scrollWidth > deviceList.clientWidth;

              if (needsScroll) {
                // 需要滚动，显示渐变遮罩
                deviceListWrapper.style.setProperty('--show-gradient', '1');

                // 添加滚动监听
                this.addScrollListener(deviceListWrapper, deviceList);
              } else {
                // 不需要滚动，隐藏渐变遮罩
                deviceListWrapper.style.setProperty('--show-gradient', '0');
              }
            });
          }

          addScrollListener(deviceListWrapper, deviceList) {
            const updateGradientVisibility = () => {
              const isAtEnd = deviceList.scrollLeft + deviceList.clientWidth >= deviceList.scrollWidth - 1;
              deviceListWrapper.style.setProperty('--show-gradient', isAtEnd ? '0' : '1');
            };

            // 初始检查
            updateGradientVisibility();

            // 添加滚动监听
            deviceList.addEventListener('scroll', updateGradientVisibility);

            // 存储监听器引用，以便后续清理
            deviceListWrapper._scrollListener = updateGradientVisibility;
          }
          init() {
            const swiperDom = this.querySelector('.ro-marine-application__container_content_right_content_main_swiper');
            const prevButton = this.querySelector('.ro-marine-application__container_handle_prev');
            const nextButton = this.querySelector('.ro-marine-application__container_handle_next');
            const leftItems = this.querySelectorAll('.ro-marine-application__container_content_left_item');
            const progressCircles = this.querySelectorAll(
              '.ro-marine-application__container_handle_next .progress-ring-progress'
            );

            const autoplayDelay = 5000; // 5秒

            new Swiper(swiperDom, {
              slidesPerView: 1.00000001,
              spaceBetween: 24,
              loop: true,
              autoplay: {
                delay: autoplayDelay,
                disableOnInteraction: false,
              },
              navigation: {
                nextEl: nextButton,
                prevEl: prevButton,
              },
              on: {
                slideChange: (swiper) => {
                  if (swiper) {
                    // 移除所有active类
                    leftItems.forEach((item) => {
                      item.classList.remove('active');
                    });
                    // 给当前slide对应的左侧内容添加active类
                    // 在loop模式下使用realIndex获取真实索引
                    const realIndex = swiper.realIndex;
                    if (leftItems[realIndex]) {
                      leftItems[realIndex].classList.add('active');
                    }
                  }
                },
                autoplayTimeLeft(s, time, progress) {
                  // 使用CSS变量更新进度
                  progressCircles.forEach((circle) => {
                    // 确保进度为1时完全填满
                    const adjustedProgress = progress >= 0.95 ? 1 : progress;
                    circle.style.setProperty('--progress', 1 - adjustedProgress);
                  });
                },
              },
            });
          }
          // 等待Swiper库加载完成
          waitForSwiper(callback) {
            const checkSwiper = () => {
              if (typeof Swiper !== 'undefined') {
                callback();
              } else {
                setTimeout(checkSwiper, 50);
              }
            };
            checkSwiper();
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ro-marine-recommend"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('ro-marine-recommend')) {
      customElements.define(
        'ro-marine-recommend',
        class RoMarineRecommend extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            console.log('ro-marine-recommend init');
            this.initTabs();
            this.init();
            this.addToCartEvent();
          }

          init() {
            const tabContent = this.querySelectorAll('.ro-marine-recommend__tab_content');

            tabContent.forEach((content) => {
              this.updateTotalPrice(content);
              content.querySelectorAll('.ro-marine-recommend__tab_product_card').forEach((card) => {
                const clickIcon = card.querySelector('.ro-marine-recommend__card_content_icon');
                clickIcon.addEventListener('click', (e) => {
                  e.preventDefault();
                  card.setAttribute('data-checked', card.getAttribute('data-checked') === 'true' ? 'false' : 'true');
                  this.updateTotalPrice(content);
                });
              });
            });
          }

          updateTotalPrice(content) {
            const selectedCards = content.querySelectorAll(
              ".ro-marine-recommend__tab_product_card[data-checked='true']"
            );
            let totalCurrentPrice = 0;
            let totalComparePrice = 0;

            selectedCards.forEach((card) => {
              const currentPrice = parseFloat(card.getAttribute('data-current-price').replace(/[^0-9.-]+/g, '')) || 0;
              const comparePrice = parseFloat(card.getAttribute('data-compare-price').replace(/[^0-9.-]+/g, '')) || 0;
              totalCurrentPrice += currentPrice;
              totalComparePrice += comparePrice;
            });

            const totalPriceElement = content.querySelector('.ro-marine-recommend__product_total_current_price');
            const totalCompareElement = content.querySelector('.ro-marine-recommend__product_total_compare_price');
            if (!totalPriceElement) return;

            totalPriceElement.textContent = `$${totalCurrentPrice.toFixed(2)}`;
            totalCompareElement.textContent = `$${totalComparePrice.toFixed(2)}`;
          }

          addToCartEvent() {
            const addToCartButtons = this.querySelectorAll('.ro-marine-recommend__product_total_price_btn');

            if (!addToCartButtons.length) return;

            addToCartButtons.forEach((btn) => {
              // 绑定点击事件
              btn.addEventListener('click', async (event) => {
                const parent = btn.closest('.ro-marine-recommend__product_total_price');
                const siblingList = parent.previousElementSibling;
                // 从该兄弟元素中查找所有 a 标签
                const productLinks = siblingList.querySelectorAll(
                  '.ro-marine-recommend__tab_product_card[data-checked="true"]'
                );
                // 组合请求参数
                const params = [];
                productLinks.forEach((link) => {
                  const variantId = link.dataset['first_variant_id'];
                  params.push({ id: variantId, quantity: 1 });
                });
                event.preventDefault();
                const button = btn.querySelector('.global-button__button');

                button.setAttribute('data-loading', 'true');

                try {
                  const response = await window.redodo.addCart(params);
                } catch (error) {
                  console.error('Error:', error);
                } finally {
                  button.setAttribute('data-loading', 'false');
                }
              });
            });
          }

          // 初始化显示第一个Tab内容
          initTabs() {
            // 获取所有Tab按钮和Swiper容器
            const tabButtons = this.querySelectorAll('.ro-marine-recommend__tab_btn');
            const tabContents = this.querySelectorAll('[data-current-tab]');

            // 为每个Tab按钮添加点击事件
            tabButtons.forEach((button, index) => {
              if (index === 0) {
                button.classList.add('active');
              }
              button.addEventListener('click', () => {
                // 移除所有按钮的active类
                tabButtons.forEach((btn) => btn.classList.remove('active'));
                // 为当前点击的按钮添加active类
                button.classList.add('active');

                tabContents.forEach((content, contentIndex) => {
                  if (index === contentIndex) {
                    content.setAttribute('data-current-tab', 'true');
                  } else {
                    content.setAttribute('data-current-tab', 'false');
                  }
                });
              });
            });
            tabContents.forEach((content, contentIndex) => {
              if (contentIndex === 0) {
                content.setAttribute('data-current-tab', 'true');
              } else {
                content.setAttribute('data-current-tab', 'false');
              }
            });
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ro-product-adsorption"] && !Shopify.designMode) return;
  try {
    
  // 将jQuery的文档加载事件改为原生JS
  document.addEventListener('DOMContentLoaded', function () {
    if (!customElements.get('ro-product-adsorption')) {
      customElements.define(
        'ro-product-adsorption',
        class RoProductAdsorption extends HTMLElement {
          sticky_start = 0;
          changeStatus = false;
          clickPoint = false;
          lastScrollTop = 0;

          constructor() {
            super();
          }

          connectedCallback() {
            this.init();
            window.addEventListener('scroll', this.scrollHandler.bind(this));
          }

          disconnectedCallback() {
            window.removeEventListener('scroll', this.scrollHandler.bind(this));
          }

          scrollHandler() {
            if (this.clickPoint) return;

            const adsorption = document.getElementById('adsorption');
            const points = document.querySelectorAll('[data-jump]');
            const sticky = adsorption.getBoundingClientRect().top + window.scrollY;

            const scrollTop = window.scrollY;
            const scrollingDown = scrollTop > (this.lastScrollTop || 0);
            this.lastScrollTop = scrollTop;

            if (scrollTop > sticky && !this.changeStatus) {
              this.changeStatus = true;
              this.sticky_start = sticky;
              adsorption.classList.add('adsorption_sticky');
              adsorption.style.top = '0';
            }

            if (this.changeStatus && window.scrollY < this.sticky_start - 10) {
              this.changeStatus = false;
              adsorption.classList.remove('adsorption_sticky');
              adsorption.style.top = '0';
            } else if (this.changeStatus) {
              adsorption.style.top = '0';
            }

            points.forEach((point) => {
              const targetPoint = point.getAttribute('data-jump');
              if (!targetPoint) return;

              let targetElement = document.getElementById(targetPoint);
              if (!targetElement) return;

              const targetOffset = targetElement.getBoundingClientRect().top + window.scrollY;
              const targetHeight = targetElement.offsetHeight;

              if (window.scrollY >= targetOffset - 50 && window.scrollY < targetOffset + targetHeight) {
                points.forEach((p) => p.classList.remove('adsorption_active'));
                point.classList.add('adsorption_active');

                const tabBox = point.closest('.point_wrapper');
                if (tabBox) {
                  const tabRect = point.getBoundingClientRect();
                  const boxRect = tabBox.getBoundingClientRect();
                  const targetScroll =
                    tabBox.scrollLeft + tabRect.left - boxRect.left - (boxRect.width - tabRect.width) / 2;
                  tabBox.scrollTo({
                    left: targetScroll,
                    behavior: 'smooth',
                  });
                }
              }
            });
          }

          init() {
            const adsorption = document.getElementById('adsorption');
            this.sticky_start = adsorption.getBoundingClientRect().top + window.scrollY;
            const points = document.querySelectorAll('[data-jump]');

            points.forEach((point) => {
              point.addEventListener('click', (e) => {
                e.preventDefault();
                if (this.clickPoint) return;

                this.clickPoint = true;

                const dataPoint = point.dataset.jump;
                if (!dataPoint) return;

                const markerPoint = document.getElementById(dataPoint);
                if (markerPoint) {
                  window.scrollTo({
                    top: markerPoint.getBoundingClientRect().top + window.scrollY + 30,
                    behavior: 'smooth',
                  });

                  setTimeout(() => {
                    this.clickPoint = false;
                    this.scrollHandler();
                  }, 300);
                } else {
                  this.clickPoint = false;
                }

                const tabBox = point.closest('.point_wrapper');
                if (tabBox) {
                  const tabRect = point.getBoundingClientRect();
                  const boxRect = tabBox.getBoundingClientRect();
                  const targetScroll =
                    tabBox.scrollLeft + tabRect.left - boxRect.left - (boxRect.width - tabRect.width) / 2;
                  tabBox.scrollTo({
                    left: targetScroll,
                    behavior: 'smooth',
                  });
                }
              });
            });
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ro-product-compare"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('ro-product-compare')) {
      customElements.define(
        'ro-product-compare',
        class RoProductCompare extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.init();
          }
          init() {
            this.initProductCompare();
            this.initCustomScrollbar();
          }

          initProductCompare() {
            const productCompare = this.querySelectorAll('.ro-product-compare__main_content_right_item_footer_button');

            if (productCompare) {
              productCompare.forEach((item) => {
                item.addEventListener('click', async () => {
                  const id = item.getAttribute('data-id');
                  const button = item.querySelector('.global-button__button');
                  button.setAttribute('data-loading', 'true');
                  try {
                    const response = await window.redodo.addCart([{ id: id, quantity: 1 }]);
                  } catch (error) {
                    console.error('Error:', error);
                  } finally {
                    button.setAttribute('data-loading', 'false');
                  }
                });
              });
            }
          }

          initCustomScrollbar() {
            const scrollContainer = this.querySelector('.ro-product-compare__main_content_right');
            const scrollbar = this.querySelector('.ro-product-compare__main_content_right_scrollbar');
            const scrollbarThumb = this.querySelector('.ro-product-compare__main_content_right_scrollbar_thumb');

            if (!scrollContainer || !scrollbar || !scrollbarThumb) return;

            // 更新滑块位置
            const updateThumbPosition = () => {
              const scrollWidth = scrollContainer.scrollWidth;
              const clientWidth = scrollContainer.clientWidth;
              const scrollLeft = scrollContainer.scrollLeft;
              const maxScroll = scrollWidth - clientWidth;
              const leftContent = this.querySelector('.ro-product-compare__main_content_left');

              if (maxScroll > 0) {
                const calculatedThumbWidth = (clientWidth / scrollWidth) * scrollbar.offsetWidth;
                const thumbWidth = Math.max(calculatedThumbWidth, 20);
                const availableWidth = scrollbar.offsetWidth - thumbWidth;
                const thumbLeft = availableWidth > 0 ? (scrollLeft / maxScroll) * availableWidth : 0;

                scrollbarThumb.style.width = thumbWidth + 'px';
                scrollbarThumb.style.left = thumbLeft + 'px';
                scrollbar.style.display = 'block';

                // 添加阴影样式
                if (leftContent) {
                  leftContent.classList.add('ro-product-compare__main_content_left_shadow');
                }
              } else {
                scrollbar.style.display = 'none';

                // 移除阴影样式
                if (leftContent) {
                  leftContent.classList.remove('ro-product-compare__main_content_left_shadow');
                }
              }
            };

            // 防抖处理resize事件
            let resizeTimeout;
            const handleResize = () => {
              clearTimeout(resizeTimeout);
              resizeTimeout = setTimeout(updateThumbPosition, 100);
            };

            // 滚动容器事件
            scrollContainer.addEventListener('scroll', updateThumbPosition);
            window.addEventListener('resize', handleResize);

            // 存储事件监听器引用，以便后续清理
            this._scrollListener = updateThumbPosition;
            this._resizeListener = handleResize;
            this._resizeTimeout = resizeTimeout;

            // 初始化滑块位置
            updateThumbPosition();
          }

          disconnectedCallback() {
            // 清理滚动条事件监听器
            if (this._scrollListener) {
              const scrollContainer = this.querySelector('.ro-product-compare__main_content_right');
              if (scrollContainer) {
                scrollContainer.removeEventListener('scroll', this._scrollListener);
              }
            }

            if (this._resizeListener) {
              window.removeEventListener('resize', this._resizeListener);
            }

            // 清理定时器
            if (this._resizeTimeout) {
              clearTimeout(this._resizeTimeout);
            }

            // 清理阴影样式
            const leftContent = this.querySelector('.ro-product-compare__main_content_left');
            if (leftContent) {
              leftContent.classList.remove('ro-product-compare__main_content_left_shadow');
            }

            // 清理引用
            this._scrollListener = null;
            this._resizeListener = null;
            this._resizeTimeout = null;
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ro-product-specification"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('ro-product-specification')) {
      customElements.define(
        'ro-product-specification',
        class RoProductSpecification extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            window.starryEventBus.on('roInitStarrySwiper', () => {
              this.init();
            });
          }
          init() {
            const swiperDom = this.querySelector('.swiper');
            const swiperButtonPrev = this.querySelector('.ro-product-specification__swiper_button_prev');
            const swiperButtonNext = this.querySelector('.ro-product-specification__swiper_button_next');
            const swiperScrollbar = this.querySelector('.ro-product-specification__swiper_scrollbar');
            new Swiper(swiperDom, {
              slidesPerView: 1,
              spaceBetween: 48,
              loop: true,
              navigation: {
                nextEl: swiperButtonNext,
                prevEl: swiperButtonPrev,
              },
              scrollbar: {
                el: swiperScrollbar,
                draggable: false,
              },
            });
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ro-product-sticky-form"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (!customElements.get('ro-product-sticky-form')) {
      customElements.define(
        'ro-product-sticky-form',
        class RoProductStickyForm extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {}
          static get observedAttributes() {
            return [
              'data-price-info',
              'data-quantity',
              'data-current-variant-id',
              'data-current-image-position',
              'data-current-image-url',
            ];
          }
          // 监听属性变化
          attributeChangedCallback(name, oldValue, newValue) {
            if (name === 'data-price-info') {
              // 默认进来会触发一次，所以需要判断oldValue是否有值，没有值说明是第一次触发
              if (oldValue && oldValue !== newValue) {
                this.triggerPriceChange();
                this.triggerPricePanelChange();
                this.triggerBottomPriceChange();
              }
            }
            if (name === 'data-quantity') {
              if (oldValue && oldValue !== newValue) {
                this.triggerPricePanelChange();
                this.triggerBottomPriceChange();
                this.triggerRecommendProductPriceChange();
              }
            }
            if (name === 'data-current-variant-id') {
              if (oldValue && oldValue !== newValue) {
                this.triggerRecommendProductChange();
                this.triggerQuantityChange(1);
                this.triggerSelectedVariantChange();
              }
            }
            if (name === 'data-current-image-position') {
              if (oldValue && oldValue !== newValue) {
                this.triggerImagePositionChange();
              }
            }
            if (name === 'data-current-image-url') {
              if (oldValue && oldValue !== newValue) {
                this.triggerImageUrlChange();
              }
            }
          }
          // 触发底部图片变化
          triggerImageUrlChange() {
            const bottomElement = this.querySelector('ro-product-sticky-form-bottom');
            if (bottomElement) {
              bottomElement.updateImageUrl(this.dataset.currentImageUrl, this.dataset.currentImagePosition);
            }
          }
          // 触发底部价格变化
          triggerBottomPriceChange() {
            const bottomElement = this.querySelector('ro-product-sticky-form-bottom');
            if (bottomElement) {
              bottomElement.updatePriceInfo(JSON.parse(this.dataset.priceInfo), Number(this.dataset.quantity));
            }
          }
          // 触发图片位置变化
          triggerImagePositionChange() {
            const leftElement = this.querySelector('ro-product-left');
            if (leftElement) {
              leftElement.switchTab(this.dataset.currentImagePosition);
            }
          }
          // 触发选中变体变化
          triggerSelectedVariantChange() {
            const variantSelectElement = this.querySelector('ro-product-content-variant-select');
            if (variantSelectElement) {
              variantSelectElement.updateSelectedVariant(this.dataset.currentVariantId);
            }
          }
          // 触发推荐产品价格变化
          triggerRecommendProductPriceChange() {
            const recommendProductElement = this.querySelector('ro-product-content-recommend-product-list');
            if (recommendProductElement) {
              recommendProductElement.updateTotalPrice();
            }
          }
          // 触发数量变化
          triggerQuantityChange(quantity) {
            const quantityElement = this.querySelector('ro-product-content-quantity');
            if (quantityElement) {
              quantityElement.updateQuantity(quantity);
            }
          }
          // 触发推荐产品变化
          triggerRecommendProductChange() {
            const recommendProductElement = this.querySelector('ro-product-content-recommend-product');
            if (recommendProductElement) {
              recommendProductElement.updateSelectedVariant(this.dataset.currentVariantId);
            }
          }
          // 触发价格面板变化
          triggerPricePanelChange() {
            const priceInfo = JSON.parse(this.dataset.priceInfo);
            const quantity = Number(this.dataset.quantity);
            const productInfoElement = this.querySelector('ro-product-content-product-info');
            if (productInfoElement) {
              productInfoElement.updatePriceInfo(priceInfo, quantity);
            }
          }
          // 触发价格修改函数
          triggerPriceChange() {
            const priceInfo = JSON.parse(this.dataset.priceInfo);
            const currentPrice = Number(priceInfo.price);
            const currentCompareAtPrice = Number(priceInfo.compareAtPrice);
            const priceNewElement = this.querySelector('.ro-product-content__price_new');
            const priceOldElement = this.querySelector('.ro-product-content__price_old');
            const quantity = Number(this.dataset.quantity);
            const priceFinalTextNumElement = this.querySelector('.ro-product-content__price_final_text_num');
            if (priceNewElement) {
              priceNewElement.innerHTML = Shopify.formatMoney(currentPrice, this.dataset.formatMoney);
            }
            if (priceOldElement) {
              priceOldElement.innerHTML = Shopify.formatMoney(currentCompareAtPrice, this.dataset.formatMoney);
            }
            if (currentCompareAtPrice && currentCompareAtPrice > currentPrice) {
              if (priceOldElement) {
                priceOldElement.classList.remove('hidden');
              }
            } else {
              if (priceOldElement) {
                priceOldElement.classList.add('hidden');
              }
            }

            if (this.dataset.showProductInfoDiscount == 'true' && priceFinalTextNumElement) {
              let shouldShowDiscount = currentCompareAtPrice && currentCompareAtPrice > currentPrice;

              switch (this.dataset.globalProductDiscountType) {
                case 'percentage':
                  // 计算折扣百分比,向下取整
                  const discountPercentage = ((currentCompareAtPrice - currentPrice) / currentCompareAtPrice) * 100;
                  const floorDiscountPercentage = Math.floor(discountPercentage);
                  if (priceFinalTextNumElement) {
                    priceFinalTextNumElement.textContent = floorDiscountPercentage;
                  }
                  // 如果百分比为0，则不显示折扣
                  if (floorDiscountPercentage === 0) {
                    shouldShowDiscount = false;
                  }
                  break;
                case 'quota':
                  // 计算折扣额度
                  const discountQuota = currentCompareAtPrice - currentPrice;
                  if (priceFinalTextNumElement) {
                    priceFinalTextNumElement.innerHTML = Shopify.formatMoney(
                      discountQuota * quantity,
                      this.dataset.formatMoney
                    );
                  }
                  break;
              }
              const priceFinalElement = this.querySelector('.ro-product-content__price_final');

              // 更新折扣信息显示
              if (shouldShowDiscount) {
                if (priceFinalElement) {
                  priceFinalElement.classList.remove('hidden');
                }
              } else {
                if (priceFinalElement) {
                  priceFinalElement.classList.add('hidden');
                }
              }
            }
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ro-product-support"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (!customElements.get('ro-product-support')) {
      customElements.define(
        'ro-product-support',
        class RoProductSupport extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.init();
          }

          init() {
            this.initTab();
            // 触发第一个tab的点击事件
            const tabItems = this.querySelectorAll('.ro-product-support__main_content_tab_item');
            if (tabItems.length > 0) {
              tabItems[0].click();
            }
          }
          initTab() {
            const tabItems = this.querySelectorAll('.ro-product-support__main_content_tab_item');
            const contentItems = this.querySelectorAll('.ro-product-support__main_content_content_item');
            tabItems.forEach((item) => {
              item.addEventListener('click', function () {
                tabItems.forEach((item) => item.classList.remove('active'));
                contentItems.forEach((item) => item.classList.remove('active'));
                item.classList.add('active');
                contentItems.forEach((contentItem) => {
                  if (contentItem.dataset.content === item.dataset.type) {
                    contentItem.classList.add('active');
                  }
                });
              });
            });
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ro-product"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('ro-product')) {
      customElements.define(
        'ro-product',
        class RoProduct extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            if (!this._roProductCartListenerAttached) {
              this._onCartButtonAreaClick = (event) => {
                const wrap = event.target.closest('.ro-product__cart_button');
                if (!wrap || !this.contains(wrap)) return;

                event.preventDefault();

                const variantId = wrap.dataset.variantId;
                if (!variantId) return;

                const quantity = 1;
                window.location.href = '/cart/' + variantId + ':' + quantity;
              };

              this.addEventListener('click', this._onCartButtonAreaClick);
              this._roProductCartListenerAttached = true;
            }

            window.starryEventBus.on('roInitStarrySwiper', () => {
              this.init();
            });
          }

          disconnectedCallback() {
            if (this._roProductCartListenerAttached && this._onCartButtonAreaClick) {
              this.removeEventListener('click', this._onCartButtonAreaClick);
              this._onCartButtonAreaClick = null;
              this._roProductCartListenerAttached = false;
            }
          }
          init() {
            // 选择 ro-product 区块内的 swiper 容器，必须和 HTML class 保持一致
            const swiperDom = this.querySelector('.ro-product__swiper');
            const prevButton = this.querySelector('.navigation_prev');
            const nextButton = this.querySelector('.navigation_next');
            new Swiper(swiperDom, {
              slidesPerView: 'auto',
              spaceBetween: 16,
              slidesOffsetBefore: 0,
              slidesOffsetAfter: 0,
              centeredSlides: false,
              navigation: {
                prevEl: prevButton,
                nextEl: nextButton,
              },
              breakpoints: {
                1201: {
                  spaceBetween: 24,
                },
              },
            });
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ro-scene-display"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('ro-scene-display')) {
      customElements.define(
        'ro-scene-display',
        class RoSceneDisplay extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            let showMoreBtn = this.querySelector('.show-more-btn');
            let showLessBtn = this.querySelector('.show-less-btn');
            showLessBtn.style.display = 'none';

            function toggleCards(show, btnToHide, btnToShow) {
              const hiddenCards = document.querySelectorAll('.mobile-hidden');

              hiddenCards.forEach((card) => {
                card.style.display = show ? 'flex' : 'none';
              });

              btnToHide.style.display = 'none';
              btnToShow.style.display = 'flex';
            }

            showMoreBtn.addEventListener('click', function () {
              toggleCards(true, this, showLessBtn);
            });

            showLessBtn.addEventListener('click', function () {
              toggleCards(false, this, showMoreBtn);
            });
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ro-scroll-info"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (!customElements.get('ro-scroll-info')) {
      customElements.define(
        'ro-scroll-info',
        class RoScrollInfo extends HTMLElement {
          constructor() {
            super();
          }
          marqueeLeftTimer;
          marqueerightTimer;
          marqueeSpeed = 1;
          connectedCallback() {
            this.initMarquee();
          }
          disconnectedCallback() {
            this.marqueeLeftTimer = null;
            this.marqueeRightTimer = null;
            clearInterval(this.marqueeLeftTimer);
            clearInterval(this.marqueeRightTimer);
          }

          disconnectedCallback() {
            // 清理定时器防止内存泄漏
            if (this.marqueeLeftTimer) {
              clearInterval(this.marqueeLeftTimer);
            }
            if (this.marqueeRightTimer) {
              clearInterval(this.marqueeRightTimer);
            }
          }

          initMarquee() {
            const marqueeContainers = this.querySelectorAll('.marquee_container');
            const roScrollInfoMarquee = this.querySelector('.ro-scroll-info__marquee');
            const roScrollInfoMarqueeWidth = roScrollInfoMarquee.clientWidth;
            console.log('roScrollInfoMarqueeWidth', roScrollInfoMarqueeWidth);
            marqueeContainers.forEach((marqueeContainer) => {
              const direction = marqueeContainer.dataset.direction;
              const marquee = marqueeContainer.querySelector('.marquee_list');
              const clone = marquee.innerHTML;

              if (direction === 'left') {
                marquee.innerHTML = clone + clone;

                setTimeout(() => {
                  const marqueeWidth = marquee.scrollWidth / 2;
                  let scrollPosition = 0;

                  this.marqueeLeftTimer = setInterval(() => {
                    scrollPosition += this.marqueeSpeed;
                    if (window.innerWidth <= 576) {
                      if (scrollPosition >= marqueeWidth + 15) {
                        scrollPosition = 0;
                      }
                    } else {
                      if (scrollPosition >= marqueeWidth + 34) {
                        scrollPosition = 0;
                      }
                    }
                    marqueeContainer.scrollLeft = scrollPosition;
                  }, 20);
                }, 100);
              }
              if (direction === 'right') {
                marquee.innerHTML = clone + clone;

                setTimeout(() => {
                  const marqueeWidth = marquee.scrollWidth / 2;
                  let scrollPosition = marqueeWidth;

                  this.marqueeRightTimer = setInterval(() => {
                    scrollPosition -= this.marqueeSpeed;
                    if (scrollPosition <= 0) {
                      scrollPosition = marqueeWidth;
                    }
                    marqueeContainer.scrollLeft = scrollPosition;
                  }, 10);
                }, 100);
              }

              // 鼠标悬停时减速
              this.querySelector('.ro-scroll-info__marquee').addEventListener('mouseenter', () => {
                this.marqueeSpeed = 0.5;
              });
              this.querySelector('.ro-scroll-info__marquee').addEventListener('mouseleave', () => {
                this.marqueeSpeed = 1;
              });
            });
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ro-trustpilot-review-collector"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ro-trustpilot-review-collector')) {
    customElements.define(
      'ro-trustpilot-review-collector',
      class RoTrustpilotReviewCollector extends HTMLElement {
        connectedCallback() {
          this.initWidget();
        }

        disconnectedCallback() {
          const widget = this.getWidgetElement();
          if (widget) {
            widget.onReady = null;
          }
        }

        getWidgetElement() {
          const widgetId = this.getAttribute('data-widget-id');
          return widgetId ? document.getElementById(widgetId) : null;
        }

        waitForTrustpilotWidget() {
          if (window.customElements.get('trustbox-verified-review-collector')) {
            return Promise.resolve();
          }

          return customElements.whenDefined('trustbox-verified-review-collector');
        }

        getBaseUrl() {
          if (window.Shopify && window.Shopify.shop === 'dev-askstarry.myshopify.com') {
            return 'https://dev-api.askstarry.com';
          }
          return 'https://api.askstarry.com';
        }

        modifyTimestamp(timestamp, mod = 10) {
          const str = timestamp.toString();
          const first12 = str.slice(0, 12);
          const sum = [...first12].reduce((acc, digit) => acc + Number(digit), 0);
          const replacement = sum % mod;
          return Number(first12 + replacement);
        }

        buildRequestBody() {
          const pageType = this.getAttribute('data-page-type');
          const customerId = this.getAttribute('data-customer-id');
          const shop = window.Shopify ? window.Shopify.shop : '';

          if (pageType === 'order') {
            return {
              shop,
              type: 'order',
              customerId: String(customerId),
              orderId: String(this.getAttribute('data-order-id') || ''),
              orderNumber: this.getAttribute('data-order-number') || '',
            };
          }

          return {
            shop,
            type: 'page',
            customerId: String(customerId),
            reference: this.getAttribute('data-reference') || '',
          };
        }

        buildRequestHeaders() {
          return {
            'Content-Type': 'application/json',
            nonce: this.getAttribute('data-nonce'),
            ticket: this.getAttribute('data-ticket'),
            timestamp: this.modifyTimestamp(Date.now()),
            shop: window.Shopify ? window.Shopify.shop : '',
          };
        }

        extractPayload(responseData) {
          if (!responseData || typeof responseData !== 'object') {
            return null;
          }

          const payload = responseData.data && responseData.iv ? responseData : responseData.data;

          if (payload && payload.data && payload.iv && payload.tag && payload.sig) {
            return payload;
          }

          return null;
        }

        async fetchEncryptedPayload() {
          const response = await fetch(this.getBaseUrl() + '/business-api/trustpilot/verified-review-collector', {
            method: 'POST',
            headers: this.buildRequestHeaders(),
            body: JSON.stringify(this.buildRequestBody()),
          });

          if (!response.ok) {
            throw new Error('Trustpilot API request failed with status ' + response.status);
          }

          const responseData = await response.json();

          if (responseData.code && responseData.code !== 200) {
            throw new Error(responseData.message || 'Trustpilot API request failed');
          }

          const payload = this.extractPayload(responseData);

          if (!payload) {
            throw new Error('Trustpilot API returned invalid payload');
          }

          return payload;
        }

        async initWidget() {
          const widget = this.getWidgetElement();

          if (!widget) {
            return;
          }

          try {
            await this.waitForTrustpilotWidget();

            widget.onReady = async () => {
              try {
                const payload = await this.fetchEncryptedPayload();

                widget.dispatchEvent(
                  new CustomEvent('customerDataResponse', {
                    detail: payload,
                  })
                );
              } catch (error) {
                console.error('[ro-trustpilot-review-collector]', error);
              }
            };
          } catch (error) {
            console.error('[ro-trustpilot-review-collector]', error);
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ro-welfare"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (!customElements.get('ro-welfare')) {
      customElements.define(
        'ro-welfare',
        class RoWelfare extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            const scrollContainer = document.querySelector('.ro-welfare__list');

            scrollContainer.addEventListener('wheel', (event) => {
              if (window.innerWidth <= 1200) {
                const scrollAmount = Math.min(scrollContainer.clientWidth, 200);
                scrollContainer.scrollBy({
                  left: event.deltaY > 0 ? scrollAmount : -scrollAmount,
                  behavior: 'smooth',
                });
              }
            });
          }
          disconnectedCallback() {
            this.removeEventListener('wheel');
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scenario-rv-category"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('scenario-rv-category')) {
      customElements.define(
        'scenario-rv-category',
        class ScenarioRvCategory extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            const scenesDom = this.querySelector('.rv-scenes_wrapper');
            this.waitForSwiper(() => {
              this.initSwiper();
            });
            this.init();
            // 监听窗口大小变化
            window.addEventListener('resize', this.init.bind(this));
            scenesDom.addEventListener('scroll', window.redodo.debounce(this.handleMaskHide.bind(this), 50));
          }
          initSwiper() {
            // 选择 ro-product 区块内的 swiper 容器，必须和 HTML class 保持一致
            const swiperDom = this.querySelector('.swiper');
            const scrollbarDom = this.querySelector('.swiper-scrollbar');
            const prevButton = this.querySelector('.navigation_prev');
            const nextButton = this.querySelector('.navigation_next');
            new Swiper(swiperDom, {
              slidesPerView: 8,
              navigation: {
                prevEl: prevButton,
                nextEl: nextButton,
              },
              breakpoints: {
                769: {},
              },
            });
          }
          init() {
            const scenesDom = this.querySelector('.rv-scenes_wrapper');
            const scenesLeftDom = this.querySelector('.rv-scenes_wrapper_left');
            const scenesRightDom = this.querySelector('.rv-scenes_wrapper_right');
            const scrollLeft = scenesDom.scrollLeft;

            if (scenesDom.scrollWidth > scenesDom.clientWidth) {
              // 容器可滚动：继续判断是否滚动到两侧
              scenesLeftDom.style.display = 'block';
              scenesRightDom.style.display = 'block';
              this.handleMaskHide();
            } else {
              scenesLeftDom.style.display = 'none';
              scenesRightDom.style.display = 'none';
            }
          }

          // 等待Swiper库加载完成
          waitForSwiper(callback) {
            const checkSwiper = () => {
              if (typeof Swiper !== 'undefined') {
                callback();
              } else {
                setTimeout(checkSwiper, 50);
              }
            };
            checkSwiper();
          }

          handleMaskHide() {
            const scenesDom = this.querySelector('.rv-scenes_wrapper');
            const scenesLeftDom = this.querySelector('.rv-scenes_wrapper_left');
            const scenesRightDom = this.querySelector('.rv-scenes_wrapper_right');

            const isAtStart = this.isScrolledToStart(scenesDom);
            const isAtEnd = this.isScrolledToEnd(scenesDom);
            const canScroll = this.canScrollHorizontally(scenesDom);

            // 隐藏逻辑
            scenesLeftDom.style.display = canScroll && !isAtStart ? 'block' : 'none';
            scenesRightDom.style.display = canScroll && !isAtEnd ? 'block' : 'none';
          }
          // 判断是否滚动到最左边
          isScrolledToStart(container, tolerance = 1) {
            if (!container) return true;
            return container.scrollLeft <= tolerance;
          }

          // 判断是否滚动到最右边
          isScrolledToEnd(container, tolerance = 1) {
            if (!container) return true;
            const maxScrollLeft = container.scrollWidth - container.clientWidth;
            return container.scrollLeft >= maxScrollLeft - tolerance;
          }

          // 判断是否可以横向滚动
          canScrollHorizontally(container, minDistance = 10) {
            if (!container) return false;
            const maxScrollLeft = container.scrollWidth - container.clientWidth;
            return maxScrollLeft > minDistance;
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scenario-rv-customer"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (!customElements.get('scenario-rv-customer')) {
      customElements.define(
        'scenario-rv-customer',
        class ScenarioRvCustomer extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.init();
          }

          init() {
            const customerChatBtn = this.querySelector('.scenario-rv-customer__content_btn');
            customerChatBtn.addEventListener('click', () => {
              window.redodo.openChatApp();
            });
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scenario-rv-nav"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('scenario-rv-nav')) {
      customElements.define(
        'scenario-rv-nav',
        class ScenarioRvNav extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            // 先执行不依赖Swiper的初始化
            this.initBasic();

            // 等待Swiper库加载完成后再执行完整初始化
            this.waitForSwiper(() => {
              this.init();
            });

            window.starryEventBus.on('roInitStarrySwiper', () => {
              this.init();
            });
            this.anchorScrollSpy(
              "[id^='scenario-rv-'], section div[id]", // 匹配所有 锚点内容
              'scenario-rv-nav a', // 导航链接选择器
              'active', // 高亮 class
              0.4 // 可见比例阈值
            );

            this.handleScroll();
            this.initAncor();
            this.handleNavSticky();

            // 监听窗口大小变化，智能重新计算是否需要Swiper
            this.resizeHandler = window.redodo.debounce(() => {
              this.handleResize();
            }, 100);
            window.addEventListener('resize', this.resizeHandler);
          }

          disconnectedCallback() {
            window.removeEventListener('scroll');
            window.removeEventListener('resize');
            if (this.resizeHandler) {
              window.removeEventListener('resize', this.resizeHandler);
            }
          }

          // 基础初始化，不依赖Swiper库
          initBasic() {
            const swiperDom = this.querySelector('.scenario-rv-nav__swiper');
            const prevButton = this.querySelector('.navigation_prev');
            const nextButton = this.querySelector('.navigation_next');

            if (!swiperDom || !prevButton || !nextButton) return;

            // 先隐藏按钮，等待Swiper库加载后再决定是否显示
            prevButton.style.display = 'none';
            nextButton.style.display = 'none';

            // 移除Swiper类，使用基础flex布局
            swiperDom.classList.remove('swiper');
            const wrapper = swiperDom.querySelector('.scenario-rv-nav__swiper_wrapper');
            if (wrapper) wrapper.classList.remove('swiper-wrapper');
            const navItems = this.querySelectorAll('.scenario-rv-nav__slide');
            navItems.forEach((item) => item.classList.remove('swiper-slide'));
          }

          // 等待Swiper库加载完成
          waitForSwiper(callback) {
            const checkSwiper = () => {
              if (typeof Swiper !== 'undefined') {
                callback();
              } else {
                setTimeout(checkSwiper, 50);
              }
            };
            checkSwiper();
          }
          init() {
            // 检查Swiper库是否可用
            if (typeof Swiper === 'undefined') {
              console.warn('Swiper库未加载，跳过导航初始化');
              return;
            }

            // 选择 ro-product 区块内的 swiper 容器，必须和 HTML class 保持一致
            const swiperDom = this.querySelector('.scenario-rv-nav__swiper');
            const prevButton = this.querySelector('.navigation_prev');
            const nextButton = this.querySelector('.navigation_next');

            if (!swiperDom || !prevButton || !nextButton) return;

            // 销毁现有的Swiper实例
            if (this.swiperInstance) {
              this.swiperInstance.destroy(true, true);
              this.swiperInstance = null;
            }

            // 恢复原始状态
            swiperDom.classList.add('swiper');
            const wrapper = swiperDom.querySelector('.scenario-rv-nav__swiper_wrapper');
            if (wrapper) wrapper.classList.add('swiper-wrapper');
            const navItems = this.querySelectorAll('.scenario-rv-nav__slide');
            navItems.forEach((item) => item.classList.add('swiper-slide'));

            // 显示导航按钮
            prevButton.style.display = '';
            nextButton.style.display = '';

            // 等待DOM更新后再计算
            requestAnimationFrame(() => {
              // 检查是否需要启用Swiper
              const containerWidth = this.querySelector('.scenario-rv-nav__content').offsetWidth;
              const titleWidth = this.querySelector('.scenario-rv-nav__title').offsetWidth;
              const availableWidth = containerWidth - titleWidth - 100; // 预留按钮和间距空间

              let totalItemsWidth = 0;
              navItems.forEach((item) => {
                totalItemsWidth += item.offsetWidth + 30; // 包含间距
              });

              // 如果所有导航项的总宽度小于可用宽度，则不启用Swiper
              if (totalItemsWidth <= availableWidth) {
                // 移除Swiper类，让导航项正常显示
                swiperDom.classList.remove('swiper');
                if (wrapper) wrapper.classList.remove('swiper-wrapper');
                navItems.forEach((item) => item.classList.remove('swiper-slide'));

                // 隐藏导航按钮
                prevButton.style.display = 'none';
                nextButton.style.display = 'none';

                return;
              }

              // 需要滚动时才启用Swiper
              try {
                this.swiperInstance = new Swiper(swiperDom, {
                  slidesPerView: 'auto',
                  spaceBetween: 30,
                  slidesOffsetBefore: 0,
                  slidesOffsetAfter: 0,
                  centeredSlides: false,
                  navigation: {
                    prevEl: prevButton,
                    nextEl: nextButton,
                  },
                  breakpoints: {
                    1201: {
                      spaceBetween: 24,
                      slidesOffsetAfter: 70,
                    },
                  },
                });
              } catch (error) {
                console.error('Swiper初始化失败:', error);
                // 如果Swiper初始化失败，回退到基础布局
                swiperDom.classList.remove('swiper');
                if (wrapper) wrapper.classList.remove('swiper-wrapper');
                navItems.forEach((item) => item.classList.remove('swiper-slide'));
                prevButton.style.display = 'none';
                nextButton.style.display = 'none';
              }
            });
          }

          // 锚点链接对应展示高亮处理
          anchorScrollSpy(anchorSelector, navSelector, activeClass = 'active', threshold = 0.6) {
            const anchors = document.querySelectorAll(anchorSelector);
            const navLinks = document.querySelectorAll(navSelector);

            if (!anchors.length || !navLinks.length) return;

            const observer = new IntersectionObserver(
              (entries) => {
                entries.forEach((entry) => {
                  if (entry.isIntersecting) {
                    const id = entry.target.getAttribute('id');

                    // 移除所有高亮
                    navLinks.forEach((link) => link.classList.remove(activeClass));

                    // 当前导航高亮
                    const activeLink = document.querySelector(`${navSelector}[href="#${id}"]`);
                    if (activeLink) {
                      activeLink.classList.add(activeClass);

                      // 当锚点激活时，确保Swiper显示并滚动到当前激活项
                      this.ensureSwiperVisible(activeLink);
                    }
                  }
                });
              },
              {
                root: null,
                rootMargin: '0px',
                threshold,
              }
            );

            anchors.forEach((anchor) => observer.observe(anchor));
          }

          initAncor() {
            // 监听所有锚点链接的点击事件
            const _this = this;
            this.querySelectorAll('a[href*="#"]').forEach((anchor) => {
              anchor.addEventListener('click', function (e) {
                e.preventDefault();

                const targetId = this.getAttribute('href').substring(1);
                const targetElement = document.getElementById(targetId);

                if (targetElement) {
                  // 平滑滚动到目标位置
                  targetElement.scrollIntoView({
                    behavior: 'smooth',
                  });

                  // 记录当前锚点
                  window.currentAnchor = targetId;
                  console.log('跳转到锚点:', targetId);

                  // 更新活跃状态
                  _this.updateActiveAnchor(targetId);
                }
              });
            });
          }

          handleNavSticky() {
            const navElement = this.querySelector('.scenario-rv-nav__container');
            if (!navElement) return;

            // 获取导航组件的实际位置（相对于页面顶部）
            const navRect = navElement.getBoundingClientRect();
            const initialOffsetTop = navRect.top + window.pageYOffset;
            console.log('导航组件位置信息:', {
              offsetTop: navElement.offsetTop,
              getBoundingClientRect_top: navRect.top,
              pageYOffset: window.pageYOffset,
              calculatedOffsetTop: initialOffsetTop,
              navRect: navRect,
            });
            let isSticky = false;

            // 创建占位元素 - 放在navElement的同一层级
            const placeholder = document.createElement('div');
            placeholder.className = 'scenario-rv-nav__placeholder';
            placeholder.style.height = navElement.offsetHeight + 'px';
            placeholder.style.display = 'none'; // 初始隐藏

            // 插入到navElement之前
            navElement.parentNode.insertBefore(placeholder, navElement);

            const scrollHandler = () => {
              const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

              if (scrollTop > initialOffsetTop && !isSticky) {
                navElement.classList.add('scenario-sticky-nav');
                placeholder.style.display = 'block'; // 显示占位元素
                placeholder.style.height = navElement.offsetHeight + 'px';
                isSticky = true;
              } else if (scrollTop <= initialOffsetTop && isSticky) {
                navElement.classList.remove('scenario-sticky-nav');
                placeholder.style.display = 'none'; // 隐藏占位元素
                isSticky = false;
              }
            };

            // 使用防抖函数
            const debouncedScroll = window.redodo.debounce(scrollHandler, 10);
            const debouncedResize = window.redodo.debounce(() => {
              if (isSticky) {
                placeholder.style.height = navElement.offsetHeight + 'px';
              }
            }, 100);

            // 初始检查和添加监听
            scrollHandler();
            window.addEventListener('scroll', debouncedScroll);
            window.addEventListener('resize', debouncedResize);
          }

          // 监听全局滚动，处理吸顶效果与顶部导航栏展示，方式叠加展示
          handleScroll() {
            // 监听滚动事件，判断当前顶部导航是否吸顶展示
            const starryHeaderEle = document.querySelector('.ro-header__container'); // 全局获取顶部导航元素
            const navElement = this.querySelector('.scenario-rv-nav__container');
            const placeholder = this.querySelector('.scenario-rv-nav__placeholder');
            const prevButton = this.querySelector('.navigation_prev');
            const nextButton = this.querySelector('.navigation_next');
            const swiperDom = this.querySelector('.scenario-rv-nav__swiper');

            // 保存原始背景颜色
            const originalBgColor =
              navElement.style.background ||
              navElement.style.backgroundColor ||
              getComputedStyle(navElement).backgroundColor;
            const originalPrevBgColor =
              prevButton.style.background ||
              prevButton.style.backgroundColor ||
              getComputedStyle(prevButton).backgroundColor;
            const originalNextBgColor =
              nextButton.style.background ||
              nextButton.style.backgroundColor ||
              getComputedStyle(nextButton).backgroundColor;

            window.addEventListener('scroll', () => {
              const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
              const starryHeaderHeight = starryHeaderEle.offsetHeight;

              if (scrollTop > starryHeaderHeight) {
                setTimeout(() => {
                  navElement.style.transition = 'top 0.3s ease-in-out';
                }, 0);

                navElement.style.background = '#fff';
                prevButton.style.background = '#fff';
                nextButton.style.background = '#fff';

                if (scrollTop < this.lastScrollTop) {
                  navElement.style.top = `${starryHeaderHeight}px`;
                  navElement.style.zIndex = `198`;
                } else {
                  navElement.style.top = 0;
                }
              } else {
                // 当滚动位置小于头部高度时，恢复原始背景颜色
                navElement.style.background = originalBgColor;
                prevButton.style.background = originalPrevBgColor;
                nextButton.style.background = originalNextBgColor;
                navElement.style.top = '';
                navElement.style.zIndex = '';
              }

              this.lastScrollTop = scrollTop;
            });
          }

          // 智能处理窗口大小变化
          handleResize() {
            const swiperDom = this.querySelector('.scenario-rv-nav__swiper');
            const prevButton = this.querySelector('.navigation_prev');
            const nextButton = this.querySelector('.navigation_next');
            const wrapper = swiperDom.querySelector('.scenario-rv-nav__swiper_wrapper');
            const navItems = this.querySelectorAll('.scenario-rv-nav__slide');

            if (!swiperDom || !prevButton || !nextButton) return;

            // 重新计算宽度
            const containerWidth = this.querySelector('.scenario-rv-nav__content').offsetWidth;
            const titleWidth = this.querySelector('.scenario-rv-nav__title').offsetWidth;
            const availableWidth = containerWidth - titleWidth - 100;

            let totalItemsWidth = 0;
            navItems.forEach((item) => {
              totalItemsWidth += item.offsetWidth + 30;
            });

            const needsSwiper = totalItemsWidth > availableWidth;
            const hasSwiper = this.swiperInstance !== null;

            // 只有在需要状态改变时才重新初始化
            if (needsSwiper && !hasSwiper) {
              // 需要Swiper但没有，重新初始化
              this.init();
            } else if (!needsSwiper && hasSwiper) {
              // 不需要Swiper但有，销毁Swiper
              this.swiperInstance.destroy(true, true);
              this.swiperInstance = null;

              // 移除Swiper类，让导航项正常显示
              swiperDom.classList.remove('swiper');
              if (wrapper) wrapper.classList.remove('swiper-wrapper');
              navItems.forEach((item) => item.classList.remove('swiper-slide'));

              // 隐藏导航按钮
              prevButton.style.display = 'none';
              nextButton.style.display = 'none';
            }
            // 如果状态没有改变，什么都不做
          }

          // 确保Swiper显示并滚动到当前激活项
          ensureSwiperVisible(activeLink) {
            // 只有当Swiper已经初始化时才执行滚动逻辑
            if (this.swiperInstance && activeLink) {
              const swiperDom = this.querySelector('.scenario-rv-nav__swiper');
              const activeIndex = Array.from(swiperDom.querySelectorAll('.scenario-rv-nav__slide')).indexOf(activeLink);
              if (activeIndex !== -1) {
                this.swiperInstance.slideTo(activeIndex, 300); // 300ms动画
              }
            }
          }

          updateActiveAnchor(anchorId) {
            // 移除所有活跃状态
            document.querySelectorAll('a[href*="#"]').forEach((link) => {
              link.classList.remove('active');
            });

            // 添加当前活跃状态
            const activeLink = document.querySelector(`a[href="#${anchorId}"]`);
            if (activeLink) {
              activeLink.classList.add('active');
            }
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scenario-rv-power"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('scenario-rv-power')) {
      customElements.define(
        'scenario-rv-power',
        class ScenarioRvPower extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.initTabs();
          }

          // 初始化显示第一个Tab内容
          initTabs() {
            // 获取所有Tab按钮和Swiper容器
            const tabButtons = this.querySelectorAll('.scenario-rv-power__tab_btn');
            const tabContents = this.querySelectorAll('[data-current-tab]');

            // 为每个Tab按钮添加点击事件
            tabButtons.forEach((button, index) => {
              button.addEventListener('click', () => {
                // 移除所有按钮的active类
                tabButtons.forEach((btn) => btn.classList.remove('active'));
                // 为当前点击的按钮添加active类
                button.classList.add('active');

                tabContents.forEach((centent, contentIndex) => {
                  if (index === contentIndex) {
                    centent.setAttribute('data-current-tab', 'true');
                  } else {
                    centent.setAttribute('data-current-tab', 'false');
                  }
                });
              });
            });
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scenario-rv-recommend"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('scenario-rv-recommend')) {
      customElements.define(
        'scenario-rv-recommend',
        class ScenarioRvRecommend extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            console.log('scenario-rv-recommend init');
            this.initTabs();
            window.starryEventBus.on('roInitStarrySwiper', () => {
              console.log('scenario-rv-recommend swiper init');
              this.init();
            });
          }

          init() {
            const swiperDoms = this.querySelectorAll('.scenario-rv-recommend__tab_item_product');

            swiperDoms.forEach((swiperDom) => {
              const prevButton = swiperDom.querySelector('.navigation_prev');
              const nextButton = swiperDom.querySelector('.navigation_next');
              this.initSwier(swiperDom, prevButton, nextButton);
            });
          }

          initSwier(swiperDom, prevButton, nextButton) {
            new Swiper(swiperDom, {
              slidesPerView: 'auto',
              slidesPerGroup: 1, // 每次只切换一个slide
              spaceBetween: 16,
              slidesOffsetBefore: 16,
              slidesOffsetAfter: 16,
              centeredSlides: false,
              noSwiping: true,
              navigation: {
                prevEl: prevButton,
                nextEl: nextButton,
              },
              breakpoints: {
                577: {
                  slidesPerView: 'auto',
                  slidesPerGroup: 1, // 每次只切换一个slide
                  spaceBetween: 24,
                  slidesOffsetBefore: 32,
                  slidesOffsetAfter: 32,
                },
                1201: {
                  slidesPerView: 4,
                  slidesPerGroup: 4, // 每次只切换一个slide
                  spaceBetween: 24,
                  slidesOffsetBefore: 0,
                  slidesOffsetAfter: 0,
                },
              },
            });
          }

          // 初始化显示第一个Tab内容
          initTabs() {
            // 获取所有Tab按钮和Swiper容器
            const tabButtons = this.querySelectorAll('.scenario-rv-recommend__tab_btn');
            const tabContents = this.querySelectorAll('[data-current-tab]');

            // 为每个Tab按钮添加点击事件
            tabButtons.forEach((button, index) => {
              if (index === 0) {
                button.classList.add('active');
              }
              button.addEventListener('click', () => {
                // 移除所有按钮的active类
                tabButtons.forEach((btn) => btn.classList.remove('active'));
                // 为当前点击的按钮添加active类
                button.classList.add('active');

                tabContents.forEach((content, contentIndex) => {
                  if (index === contentIndex) {
                    content.setAttribute('data-current-tab', 'true');
                  } else {
                    content.setAttribute('data-current-tab', 'false');
                  }
                });
              });
            });
            tabContents.forEach((content, contentIndex) => {
              if (contentIndex === 0) {
                content.setAttribute('data-current-tab', 'true');
              } else {
                content.setAttribute('data-current-tab', 'false');
              }
            });
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scenario-rv-scene"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('scenario-rv-scene')) {
      customElements.define(
        'scenario-rv-scene',
        class ScenarioRvScene extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.bindEvent();
          }

          bindEvent() {
            const items = this.querySelectorAll('.welfare-item');
            this.$dialog = this.querySelector('dialog-simple');

            items.forEach((item) => {
              item.addEventListener('click', (e) => {
                const target = e.currentTarget;
                this.$dialog.setAttribute('data-show', 'true');
                this.$dialog.setAttribute('data-title', target.getAttribute('data-title'));
                this.$dialog.setAttribute('data-desc', target.getAttribute('data-desc'));
              });
            });
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scenario-rv-system"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (!customElements.get('scenario-rv-system')) {
      customElements.define(
        'scenario-rv-system',
        class ScenarioRvSystem extends HTMLElement {
          constructor() {
            super();
          }

          connectedCallback() {
            this.init();
          }

          init() {
            const root = this;
            const points = root.querySelectorAll('.rv-hot-point');

            points.forEach((point) => {
              point.addEventListener('click', (e) => {
                const currentPoint = e.currentTarget;
                currentPoint.classList.toggle('active');
                console.log(111);

                const content = currentPoint.nextElementSibling;
                if (content && content.classList.contains('rv-hot-content')) {
                  content.classList.toggle('active');
                }

                points.forEach((p) => {
                  if (p !== currentPoint) {
                    p.classList.remove('active');
                    const nextContent = p.nextElementSibling;
                    if (nextContent && nextContent.classList.contains('rv-hot-content')) {
                      nextContent.classList.remove('active');
                    }
                  }
                });
              });
            });
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();
})();
